<!-- 模板的弹出框 -->
<template>
  <div class="PopupBox">
    <div
      v-loading='updateEventLoading'
      :class="[
        'createBooking',
        {
          createBookingRight: !FrameProperty.aleft,
          createBookingBottom: !FrameProperty.upward,
          createBookingRightBottom:
            !FrameProperty.aleft && !FrameProperty.upward,
        },
      ]"
      :style="{
        top: FrameProperty.top + 'px',
        left: FrameProperty.left + 'px',
      }">
      <div class="Arrows" :style="{left: FrameProperty.aleft ? FrameProperty.ArrowsLeft + 'px' : '',right: !FrameProperty.aleft ? FrameProperty.ArrowsLeft + 'px' : ''} ">
      </div>
      <!-- 头部标题 -->
      <div class="EventWrapTitle">
        <ul
          class="CompileTitle"
          v-if="UserChannelPermission != 5"
        >
          <li
            @click="CutTab('note')"
            :class="{ active: CompileType === 'note' }">
            {{ $t('lang.note') }}
          </li>
          <li class="separator">|</li>
          <li
            @click="CutTab('events')"
            :class="{ active: CompileType === 'events' }">
            {{ $t('lang.Events')}}
          </li>
          <li class="separator">|</li>
          <li
            @click="CutTab('device')"
            :class="{ active: CompileType === 'device' }">
            {{ $t('lang.device') }}
          </li>
          <li class="separator" v-if="EventMotionSelect == 1">|</li>
          <li
            v-if="EventMotionSelect == 1"
            @click="CutTab('changeLog')"
            :class="{ active: CompileType === 'changeLog' }">
            {{ $t('lang.changeLog') }}
          </li>
        </ul>
        <ul
          class="CompileTitle"
          v-else
        >
          <li
            @click="CutTab('events')"
            :class="{ active: CompileType === 'events' }">
            {{ $t('lang.Events')}}
          </li>
        </ul>
        <div
          class="iconfont closeCreateBox"
          @click="closeCreateBox">
          <i class="iconfont icon-a-closethick"></i>
        </div>
      </div>
      <!-- 创建与修改事件 -->
      <div
        class="EventUpdateandCreate"
        :id="`${(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4) ? 'EventUpdateandCreate' : ''}`"
        >
        <!-- note部分 -->
        <div
          class="note"
          v-if="CompileType === 'note'">
          <div class="c_item EventTitle">
            <input
              type="text"
              v-model="eventDetail.title"
              maxlength="220"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              :placeholder="$t('lang.createTitle')" />
            <div
              class="color_box"
              @click="mostSwitch.ColorShow = !mostSwitch.ColorShow">
              <div :class="['color', ColorTransition(eventDetail.color)]"></div>
              <i :class="['el-icon-caret-bottom', { top: mostSwitch.ColorShow }]"></i>
              <div
                class="color_opt"
                v-if="mostSwitch.ColorShow">
                <span>{{ $t('lang.color') }}</span>
                <ul>
                  <li
                    v-for="(item, index) in colorArr"
                    :key="index"
                    :class="[item.name]"
                    @click.stop="chooseColor(item)"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="DuplicateHint" v-if="IsCopyEvent">
            {{ $t('lang.Duplicate') }}
          </div>
          <div class="c_item timeSelete">
            <div class="time_opt">
              <el-date-picker
                type="datetime"
                v-model="eventDetail.startTime"
                popper-class="pick_date_time"
                :picker-options="pickerDateStart"
                :placeholder="$t('lang.selectData')"
                value-format="timestamp"
                :format="PickerFormat.DateTime"
                @change="changeStartTime"
                :disabled="(mostSwitch.IsProgress||!!eventDetail.multipleModelType)&&!IsCopyEvent">
              </el-date-picker>
            </div>
            <div class="to" @click="timeLock">
              <i class="iconfont icon-unlock1" v-if="eventDetail.timeLock == 0 || eventDetail.timeLock == 2"></i>
              <i class="iconfont icon-lock2" v-else></i>
            </div>
            <div class="time_opt">
              <el-date-picker
                type="datetime"
                v-model="eventDetail.endTime"
                popper-class="pick_date_time"
                :picker-options="pickerDateEnd"
                :placeholder="$t('lang.selectData')"
                value-format="timestamp"
                :format="PickerFormat.DateTime"
                @change="changeEndTime"
                :disabled='eventDetail.eventModelType==2||eventDetail.eventModelType==1'>
              </el-date-picker>
            </div>
          </div>
          <div class="c_item eventMode" >
            <el-checkbox class="followOnCheckbox" v-model="eventDetail.multipleModelType"  @change="followOnModeChange">{{ $t('lang.followLastEvent') }}</el-checkbox>
            <el-select
            class="moreMode"
            v-model="eventDetail.eventModelType"
            @change="changeMode"
            :popper-append-to-body='false'
            :placeholder="$t('lang.select')">
            <div
              v-for="(item, index) in modeTypeList"
              :key="index">
              <el-option
                :label="$t(`lang.${item.label}`)"
                :value="item.value"
                :title="$t(`lang.${item.label}`)"
              >
              </el-option>
            </div>
            </el-select>
          </div>
          <div class="c_item" v-if="FeaturesList.pgmStartSCTE">
            <el-checkbox  v-model="eventDetail.pgmStartScte" @change="pgmStartScteChange">{{ $t('lang.SCTEPGMStart') }}</el-checkbox>
          </div>
          <!-- <div class="c_item SctePgmStart" v-if="eventDetail.pgmStartScte">
            <public-file-select
              :SelectType="1"
              :SelectValue="{
                fileId: eventDetail.pgmStartSourceId ,
                fileName: eventDetail.pgmStartSourceName,
              }"
              :AppendBody="false"
              :disabled="eventDetail.liveStatus == 1"
              @fileSelectChange="
                pitchOnFile => fileSeleteChange(pitchOnFile, 2)
              "></public-file-select>
          </div> -->
          <div class="c_item" v-if="FeaturesList.pgmEndSCTE">
            <el-checkbox v-if="FeaturesList.pgmEndSCTE" v-model="eventDetail.pgmEndScte" @change="PushUndo">{{ $t('lang.SCTEPGMEnd') }}</el-checkbox>
          </div>
          <div class="c_item RecordSelete" v-if="eventDetail.sourceType || eventDetail.record">
            <span class="Recordhalf" v-if="eventDetail.sourceType || eventDetail.record">
              <el-checkbox v-model="eventDetail.record" :disabled="mostSwitch.IsProgress" @change="recordChange">{{ $t('lang.SecondaryRecord') }}</el-checkbox>
            </span>
            <span class="Recordhalf" v-if="eventDetail.record">
              <el-checkbox v-model="eventDetail.replay" :disabled="mostSwitch.IsProgress" @change="PushUndo">{{ $t('lang.Replay') }}</el-checkbox>
            </span>
          </div>
          <div class="c_item RepeatTypeSelect">
            <el-select
            v-model="LoopData.CustomTime"
            @change="RepeatTypeChange"
            :disabled='!!eventDetail.multipleModelType||eventDetail.eventModelType==1'
            :title="LoopData.CustomTime"
            :placeholder="$t('lang.select')">
            <div
              v-for="(item, index) in RepeatTypeList"
              :key="index">
              <el-option
                v-if="item.switch"
                :label="$t(`lang.${item.label}`)"
                :value="item.value"
              >
              </el-option>
            </div>
            </el-select>
          </div>
          <div class="c_item createEventMessage" v-if="EventMotionSelect == 1">{{createEventLog}}</div>
          <div class="c_item repeatOrigin" v-if="eventDetail.id&&eventDetail.repeatOrigin">{{$t('lang.RepeatOrigin')}}: {{repeatOrigin}}</div>
          <div class="c_item EPGFields">
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.Series')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.series" />
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.EpisodeTitle')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.episodeTitle" />
          </div>
          <div class="c_item EPGFields">
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.Season')"
              @input="onlyNumbers('Season')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.season" />
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.Episode1')"
              @input="onlyNumbers('Episode')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.episode" />
          </div>
          <div class="c_item CategoryReporter" v-if="!updateEventLoading">
            <category-select
            :placeholder="'Category'"
            :SelectValue="eventDetail.category"
            :AppendBody="false"
            @fileSelectChange="categoryChange"
            ></category-select>
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.reporter')"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.reporter" />
          </div>
          <div class="c_item HouseID">
            <p class="HouseIDKey">{{$t('lang.HouseId')}}</p>
            <p class="HouseIDVaule">
              <input
              type="text"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.houseId"
              :placeholder="$t('lang.HouseId')" />
            </p>
          </div>
          <div class="c_item TMSID">
            <p class="HouseIDKey">{{$t('lang.TMSID')}}</p>
            <p class="HouseIDVaule">
              <input
              type="text"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.tmSid"
               />
            </p>
          </div>
          <div class="c_item showOnly">
            <p class="HouseIDKey">{{$t('lang.EventID')}}</p>
            <p class="HouseIDVaule"> {{eventDetail.eventUUID}} </p>
          </div>
          <div class="c_item showOnly" v-if="eventDetail.recurEventId">
            <p class="HouseIDKey">{{$t('lang.GroupID')}}</p>
            <p class="HouseIDVaule"> {{eventDetail.recurEventId}} </p>
          </div>
          <div class="c_item Output" v-if="FeaturesList.OccasionalOutput">
            <Output
             v-if="occasionalOutputMessage"
             from="selectList"
             :ProgramItem="ProgramItem"
             :selectedAccount="eventDetail.occasionalOutputMessage"
              @AccountSelectInfo="AccountSelectInfo"
            ></Output>
          </div>
          <div class="c_item des">
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              style="height:60px;resize:none"
              maxlength="255"
              :placeholder="$t('lang.des')"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.description"></textarea>
              <span class="desNum" >{{  getLength(eventDetail.description) }}</span>
          </div>
        </div>
        <!-- events部分 -->
        <div
          class="EventsWrap"
          v-loading="TakeNextLoad"
          v-else-if="CompileType === 'events'">
          <div class="PGMScteMessage" v-if="PGMScteMessage.PGMTotalTime">
            <span>{{$t('lang.PGMTotalTime')}} {{PGMScteMessage.PGMTotalTime}}</span>
            <span>{{$t('lang.ScteTotalTime')}} {{PGMScteMessage.ScteTotalTime}}</span>
            <span>{{$t('lang.ScteNumber')}} {{PGMScteMessage.ScteNumber}}</span>
          </div>
          <div class="ReferenceMedia">
            <div class="MediaSelect">
              <div class="ReferenceMediaSelect">
                <public-multiple-select
                  v-if="MediaLiveParams"
                  :SelectType="2"
                  :configParams="MediaLiveParams"
                  :SelectValue="{
                    fileId: eventDetail.fileId,
                    fileName: eventDetail.tname,
                  }"
                  :otherParam="{placeholder: 'PrimarySource', hierarchy: 1000}"
                  @MediaLiveSelectChange="MediaLivePrimaryChange"
                  @clearMessage="clearMessage(1)"
                >
                </public-multiple-select>
              </div>
              <div class="Link" v-loading="cutSource" @click="CutMediaSource" :disabled="CloneDisabled.Event||CloneDisabled.disableButton">
                <i class="iconfont icon-switch" ></i>
              </div>
              <div class="ReferenceMediaSelect">
                <public-multiple-select
                  v-if="MediaLiveParams"
                  :SelectType="2"
                  :configParams="MediaLiveParams"
                  :SelectValue="{
                    fileId: eventDetail.secondaryTpeerid,
                    fileName: eventDetail.secondaryTname,
                  }"
                  :otherParam="{placeholder: 'SecondarySource', hierarchy: 1000}"
                  @MediaLiveSelectChange="MediaLiveSecondaryChange"
                  @clearMessage="clearMessage(2)"
                >
                </public-multiple-select>
              </div>
              <!-- 高亮框 -->
              <div class="HighLinght" :class="{ ReserveHighLinght: eventDetail.switchEventSourceType}" v-if="eventDetail.liveStatus == 1"></div>
              <!-- <public-file-select
                v-if="!eventDetail.sourceType"
                :SelectType="1"
                :SelectValue="{
                  fileId: eventDetail.fileId,
                  fileName: eventDetail.tname,
                }"
                :AppendBody="false"
                @fileSelectChange="
                  pitchOnFile => fileSeleteChange(pitchOnFile, 1)
                "></public-file-select>
              <el-select
                v-else
                v-model="eventDetail.tpeerid"
                :popper-append-to-body="false"
                v-scroll="SourcebindScroll"
                filterable
                :filter-method="SearchSource"
                :placeholder="$t('lang.select')"
                @change="SelectSource">
                <el-option
                  v-for="item in SourceList"
                  :key="item.peerId"
                  :label="item.name"
                  :value="item.peerId">
                </el-option>
              </el-select> -->
            </div>
            <div class="MediaTiming" v-if="UserChannelPermission != 5">
              <el-select v-model="eventDetail.timingId" @change="changeTimingFile" :placeholder="$t('lang.timing')" v-scroll="bindScroll" :popper-append-to-body="false" filterable :filter-method="searchFile">
                <el-option v-for="item in mcpTimingList" :key="item.id" :label="item.name" :value="item.id">
                  <span class="timing-item ellipsis" :title="item.name">{{ item.name }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="Thumbnails" v-if="UserChannelPermission != 5">
              <upload-thumbnail :SelectValue="eventDetail.thumbnail" @ThumbnailSelectChange="ThumbnailSelectChange"></upload-thumbnail>
              <!-- <input
              type="text"
              v-model="eventDetail.thumbnail"
              :placeholder="$t('lang.ThumbnailURL')" /> -->
            </div>
          </div>
          <div class="EventsTitle">
            <div class="MediaIndex"></div>
            <div class="Title-item"></div>
            <div class="Title-item">{{ $t('lang.Event') }}</div>
            <div class="Title-item FilePicker">{{ $t('lang.File') }}</div>
            <div class="Title-item timePicker">{{ $t('lang.TimingIn') }}</div>
            <div class="Title-item timePicker">{{ $t('lang.TimingOut') }}</div>
            <div class="Title-item Duration">{{ $t('lang.duration') }}</div>
          </div>
          <div class="EventsListWrap" v-if="UserChannelPermission != 5">
            <div
              class="EventsList"
              v-for="(subevent, index) in subeventList"
              :key="index">
              <div class="MediaIndex">
                <span v-if="subevent.segmentId == 1">{{ subevent.SerialNumber }}</span>
              </div>
              <!-- Segments -->
              <div class="Title-item">
                <div class="GxtScte fileSelete" v-if="!((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0||(subevent.segmentId == 13 && (subevent.eventOperationType == 'Flowics'&& subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&& subevent.singularInfoParams.type == 1)))">
                  <el-select
                    v-model="subevent.segmentId"
                    :popper-append-to-body="false"
                    :placeholder="$t('lang.select')"
                    :disabled="UnderplayClipList[subevent.blockId] > 1"
                    @focus="SelectTakeElement(subevent)"
                    :class="{'SelectTakeElement': subevent.id == TakeElementObj.id, 'LiveElement': subevent.id == TakeElementObj.selectId && TakeElementObj.switch}"
                    @change="SegmentsChang(subevent,index)">
                    <el-option
                      :title="$t(`lang.${item.label}`)"
                      v-for="item in SegmentsType"
                      :key="item.value"
                      :label="$t(`lang.${item.label}`)"
                      v-show="item.isShow"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- Event -->
              <div class="Title-item">
                <div
                  class="GxtScte fileSelete"
                  v-if="!((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0)"
                >
                  <!-- scte -->
                  <el-select
                    v-if="(subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14)"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    :popper-append-to-body="false"
                    :disabled="UnderplayClipList[subevent.blockId] > 1"
                    @change="ScteTypeChange(subevent)"
                    >
                    <el-option
                      v-for="item in ScteSpliceType"
                      :key="item.value"
                      :label="$t(`lang.${item.label}`)"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- GFX -->
                  <el-select
                    v-if="subevent.segmentId == 13&&subevent.eventOperationType != 'Flowics'&&subevent.eventOperationType != 'Singular'"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="changeSegment(subevent)"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="subevent.segmentId == 13&&subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type != 1"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="changeSegment(subevent)"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="subevent.segmentId == 13&&subevent.eventOperationType=='Singular'&&subevent.singularInfoParams.type != 1"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="changeSegment(subevent)"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                   <div class="logoAndHashText"  v-if="subevent.segmentId == 13&&subevent.eventOperationType == 'Flowics'&& subevent.iframeInfoParams.type == 1">{{subevent.iframeInfoParams.title}}</div>
                   <div class="logoAndHashText"  v-if="subevent.segmentId == 13&&subevent.eventOperationType == 'Singular'&& subevent.singularInfoParams.type == 1">{{subevent.singularInfoParams.payloadKey}}</div>
                </div>
              </div>
              <!-- File -->
              <div class="Title-item FilePicker">
                <div class="referenceName" v-if="subevent.segmentId==1">
                  {{eventDetail.liveStatus == 1 ? bePlayingSource.fileName : eventDetail.tname}}
                </div>
                <div
                  class="GxtScte fileSelete"
                  :class="{'UnderplayClipVideo': (subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block'}"
                  v-if="
                    ((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) &&
                      subevent.eventOperationType != 'Scte only') ||
                      subevent.segmentId == 4 ||
                      subevent.segmentId == 5 ||
                      subevent.segmentId == 10||
                      subevent.segmentId == 15
                  ">
                  <public-multiple-select
                    v-if="MediaLiveParams && (subevent.segmentId == 4 || subevent.segmentId == 5)"
                    :SelectType="2"
                    :configParams="MediaLiveParams"
                    :SelectValue="{
                      fileId: subevent.fileId,
                      fileName: subevent.fileName,
                    }"
                    :otherParam="{placeholder: 'select', hierarchy: subeventList.length - index}"
                    @MediaLiveSelectChange="pitchOnFile => SubeventFileDispose(pitchOnFile, subevent, index)"
                    @clearMessage="SubeventClearMessage(subevent)"
                  >
                  </public-multiple-select>
                   <public-multiple-select
                    v-if="MediaParams && (((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType != 'Scte only') || subevent.segmentId == 10||subevent.segmentId==15)"
                    :SelectType="2"
                    :configParams="subevent.segmentId==15?LiveParams:MediaParams"
                    :SelectValue="{
                      fileId: subevent.fileId,
                      fileName: subevent.fileName,
                    }"
                    :SearchTypeList="subevent.segmentId==15?[true,false,false]:[false, true, true]"
                    :otherParam="{placeholder: 'select', hierarchy: subeventList.length - index}"
                    @MediaLiveSelectChange="pitchOnFile => SubeventFileDispose(pitchOnFile, subevent, index)"
                    @clearMessage="SubeventClearMessage(subevent)"
                  >
                  </public-multiple-select>
                  <!-- <public-file-select
                    :searchType='0'
                    :SelectType="1"
                    :SelectValue="{
                      fileId: subevent.fileId,
                      fileName: subevent.fileName,
                    }"
                    :AppendBody="false"
                    @fileSelectChange="
                      pitchOnFile => fileSeleteChange(pitchOnFile, subevent, index)
                    "></public-file-select> -->
                  <div class="addUnderplayClip">
                    <i
                      v-if="(subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip != 0"
                      class="iconfont icon-add"
                      @click="addUnderplayClip(subevent,index)"></i>
                  </div>
                </div>
                <div class="fileSelete" v-if="subevent.segmentId == 13 && subevent.eventOperationType != 'SCTE'">
                  <logo-crawl-select
                  :class="subevent.showColor?'showRed':''"
                  v-if="subevent.eventOperationType != 'Flowics'&&subevent.eventOperationType != 'Singular'"
                    :SelectValue="{
                      fileId: subevent.fileIdd,
                      fileName: subevent.fileName,
                    }"
                    :FileSelectList="subevent.eventOperationType == 'Crawl' ? getCrawlList : showThumbList"
                    :AppendBody="false"
                    @fileSelectChange="
                      pitchOnFile => LogoCrawlChange(pitchOnFile, subevent)
                    "></logo-crawl-select>
                    <div v-if="subevent.eventOperationType=='Singular'&&subevent.singularInfoParams.type != 1">
                      <el-select
                      :class="subevent.showColor?'showRed':''"
                        v-model="subevent.singularInfoParams.subCompositionName"
                        :placeholder="$t('lang.select')"
                        @change="singularSelect(subevent,index)"
                        @focus="getSingularInfo"
                        :popper-append-to-body="false">
                        <el-option
                          v-for="item in singularSelectList"
                          :key="item.subCompositionId"
                          :label="item.subCompositionName"
                          :value="item.subCompositionName"
                          >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="flowicsContent" v-if="subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type != 1&&SingularMessage.flowicsToken"  :class="subevent.showColor?'showRed':''">
                      <flowics-select  class="flowicsSelect" :SingularMessage='SingularMessage'  :selectIdParam='subevent.iframeInfoParams' @FlowicsParamSelect='logoAndHashText=>FlowicsParamSelect(logoAndHashText,subevent,index)'></flowics-select>
                      <!-- <div class="flowicsAdd">
                        <i
                          class="iconfont icon-add"
                          @click="addFlowics(subevent,index)"></i>
                      </div> -->
                    </div>
                    <div class="logoAndHashValue" :title="subevent.iframeInfoParams.value" v-if="subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type == 1"><el-input v-model="subevent.iframeInfoParams.value"></el-input></div>
                    <div class="logoAndHashValue" :title="subevent.singularInfoParams.payloadValue" v-if="subevent.eventOperationType=='Singular'&&subevent.singularInfoParams.type == 1"><el-input v-model="subevent.singularInfoParams.payloadValue"></el-input></div>
                </div>
                <div class="SinglaType" v-if="subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE'">
                  <!-- singla -->
                  <el-select
                    :class="subevent.showColor?'showRed':''"
                    v-model="subevent.fileIdd"
                    :placeholder="$t('lang.select')"
                    @change="PushUndo"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in SubeventTypeSelete.TimeSignalList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div
                  class="noSelete"
                  v-else></div> -->
              </div>
              <!-- Timing-In -->
              <div class="Title-item timePicker">
                <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetIn', index)" v-if="subevent.segmentId == 13&&(((subevent.iframeInfoParams&&subevent.iframeInfoParams.type != 1)||subevent.eventOperationType!='Flowics')&&((subevent.singularInfoParams&&subevent.singularInfoParams.type != 1)||subevent.eventOperationType!='Singular'))">{{formatSeconds(subevent.OffsetIn)}}</div>
                <el-time-picker
                  v-if="!IsHoldEvents"
                  v-show="!((subevent.segmentId == 13&&subevent.eventOperationType == 'Flowics'&& subevent.iframeInfoParams.type == 1)||(subevent.segmentId == 13&&subevent.eventOperationType == 'Singular'&& subevent.singularInfoParams.type == 1))"
                  ref="SecondaryOffsetIn"
                  v-model="subevent.ShowTimingIn"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  :format="PickerFormat.Time"
                  :disabled="subevent.segmentId == 12"
                  @blur="DateChange(subevent, 'In', index)">
                </el-time-picker>
              </div>
              <!-- Timing-Out -->
              <div class="Title-item timePicker">
                <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetOut', index)" v-if="subevent.segmentId == 13 && subevent.eventOperationType != 'SCTE'&&((subevent.iframeInfoParams&&subevent.iframeInfoParams.type != 1)||subevent.eventOperationType!='Flowics')&&((subevent.singularInfoParams&&subevent.singularInfoParams.type != 1)||subevent.eventOperationType!='Singular')">{{formatSeconds(subevent.OffsetOut)}}</div>
                <el-time-picker
                  v-if="!IsHoldEvents"
                  v-show="!(subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE')&&!(subevent.eventOperationType == 'Flowics'&&subevent.iframeInfoParams.type == 1)&&!(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)"
                  ref="SecondaryOffsetOut"
                  v-model="subevent.ShowTimingOut"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  :format="PickerFormat.Time"
                  :disabled="subevent.segmentId == 12"
                  @blur="DateChange(subevent, 'Out', index)">
                </el-time-picker>
              </div>
              <!-- Duration -->
              <div class="Title-item Duration-item">
                <div class="Duration" v-if="!((subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE') || (IsHoldEvents && subevent.segmentId == 1)||(subevent.segmentId == 13 && (subevent.eventOperationType == 'Flowics'&&subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)))" @click="DurationEditShow(index)">
                  {{ calculateInterval(subevent.accumulatedProgramTiming) }}
                </div>
                <duration-edit v-if="subevent.durationEdit" :SonEventDuration="subevent.accumulatedProgramTiming" @EditEnd="(value) => DurationEditEnd(value, subevent, index)"></duration-edit>
              </div>
              <!-- 操作 -->
              <div class="operation-item">
                <span
                  :title="$t('lang.insertRowDown')"
                  v-if="subevent.segmentId != 7 && !((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0)&&!(subevent.segmentId == 13 && ((subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)))"
                  class="iconfont i-insert"
                  @click="addSubevent('insertion ',index, subevent)">
                  <img src="@/assets/img/insert.png">
                </span>
                <div
                v-if="!(subevent.segmentId == 13 && ((subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)))"
                  class="delete"
                  :class="{'leftM': subevent.segmentId == 7 || ((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0)}"
                  @click="deleteSubevent(subevent, index)">
                  <i class="iconfont icon-icon14"></i>
                </div>
              </div>
              <div class="LiveEventItem" v-if="CurrentPlayoutEvent && CurrentPlayoutEvent == subevent.eventTemplateId"></div>
            </div>
            <div class="addSubevent">
              <i
                class="iconfont icon-add"
                @click="addSubevent('end')"></i>
            </div>
          </div>
          <EventsStaticShow
            v-else
            :eventDetail="eventDetail"
            :bePlayingSource="bePlayingSource"
            :subeventList="subeventList"
            :IsHoldEvents="IsHoldEvents"
            :TakeElementObj="TakeElementObj"
            :SegmentsType="SegmentsType"
            :CurrentPlayoutEvent="CurrentPlayoutEvent"
            @SelectTakeElement="SelectTakeElement"
            >
          </EventsStaticShow>
        </div>
        <!-- device部分 -->
        <div
          class="device"
          v-else-if="CompileType === 'device'">
          <div class="d_item source">
            <span>{{ $t('lang.bookingChannel') }}</span>
            <span class="val">{{ eventDetail.rname }}</span>
          </div>
          <div class="d_item">
            <span>{{ $t('lang.delay') }}{{ Rversions ? '(0.3-50s)' : '(0.5-50s)' }}</span>
            <input
              type="text"
              :class="['input', { delay: mostSwitch.editDelay }]"
              v-model="eventDetail.delay"
              @focus="mostSwitch.editDelay = true"
              @blur="DelayBitChange('editDelay')"
              oninput="value=value.replace(/[^\d.]/g,'')" />
          </div>
          <div class="d_item">
            <span>{{ $t('lang.bit') }}(100-10240Kbps)</span>
            <input
              type="text"
              :class="['input', { bitrate: mostSwitch.editBit }]"
              v-model="eventDetail.bitrate"
              @focus="mostSwitch.editBit = true"
              @blur="DelayBitChange('editBit')"
              oninput="value=value.replace(/[^\d.]/g,'')" />
          </div>
        </div>
        <!-- ChangeLog -->
        <div class="ChangeLog" v-else v-loading="eventLogLoading" v-scroll="bindEventLogScroll">
          <div class="log-item" v-for="(item,index) in EventChangeLog" :key="index">
            <div><span class="log-time">{{item.updateTime}}</span>  <span class="log-user">{{item.email}}</span></div>
            <div class="log-content">{{ShowLogData(item)}}</div>
          </div>
        </div>
      </div>
      <action-tip v-if="LoopDialog.switch" :LoopDialog="LoopDialog" @deleteLoopEvent="DeleteQuest" @updateLoopEvent="SaveQuest"></action-tip>
      <loop-event-time v-if="RepeatCustom" :picthOnEvent="eventDetail" :LoopData="LoopData" :location="FrameProperty.aleft" @CustomTimeSelect="CustomTimeSelect"></loop-event-time>
      <media-time-floor v-if="MediaTimeFloor.show" :MediaTimeFloor="MediaTimeFloor" @RoundSelectRes="RoundSelectRes"></media-time-floor>
      <follow-on-select v-if="followOnDialog" :followOnDialog='followOnDialog' @followOnSelect='followOnSelect'></follow-on-select>
      <over-video-time v-if="OverVideoTime.show" :OverVideoTime="OverVideoTime" @OverTimeSelect="OverTimeSelect" ></over-video-time>
      <!-- 底下的操作 -->
      <div class="create_footer" v-if="UserChannelPermission != 5">
        <el-button
          :disabled="CloneDisabled.Event||CloneDisabled.disableButton"
          v-if="EventMotionSelect == 1 && CompileType === 'events'"
          @click="TakeElement"
          :class="['TakeElement', {'NOElement': !TakeElementObj.id}]">
          {{$t('lang.takeElement')}}
        </el-button>
        <el-button
          type="danger"
          class="TakeNextSubevent"
          :disabled="CloneDisabled.Event||CloneDisabled.disableButton"
          :loading='TakeNextLoad'
          @click="TakeNextSubevent"
          v-if="EventMotionSelect == 1 && CompileType === 'events' && eventDetail.liveStatus == 1 && FeaturesList['Rundown PGM Templates']">
          {{$t('lang.nextSeg')}}
        </el-button>
        <div
          class="DetailButton"
          v-show="EventMotionSelect == 1">
          <button
            :disabled="CloneDisabled.Event || daylightSavingTime||CloneDisabled.disableButton"
            class="delete"
            v-if="!(eventDetail.liveStatus == 2)"
            @click="DeleteEvent">
            {{ $t('lang.delete') }}
          </button>
          <button
            :disabled="CloneDisabled.Event||CloneDisabled.disableButton"
            class="copy"
            :style="{'margin-right':(eventDetail.liveStatus == 2) ? '50px': ''}"
            @click="copyEvent">
            {{ $t('lang.copy') }}
          </button>
          <!-- <button class="edit" @click="EventMotionSelect = 1">
            {{ $t("lang.edit") }}
          </button> -->
        </div>
        <div
          class="ComplieButton"
          v-show="EventMotionSelect != 0">
          <button
            class="cancel"
            @click="closeCreateBox">
            {{ $t('lang.cancel') }}
          </button>
          <button
            :disabled="CloneDisabled.Event || daylightSavingTime||CloneDisabled.disableButton"
            class="save f_right"
            v-show="EventMotionSelect == 1 && !(eventDetail.liveStatus == 2)"
            @click="SaveEvent">
            {{ $t('lang.save') }}
          </button>
          <button
            :disabled="CloneDisabled.Event||CloneDisabled.disableButton"
            class="save"
            v-show="EventMotionSelect == 2"
            @click="CreateEvent">
            {{ $t('lang.create') }}
          </button>
        </div>
      </div>
      <div class="create_footer" v-else>
        <el-button
          :disabled="CloneDisabled.Event||CloneDisabled.disableButton"
          v-if="EventMotionSelect == 1 && CompileType === 'events'"
          @click="TakeElement"
          :class="['TakeElement', {'NOElement': !TakeElementObj.id}]">
          {{$t('lang.takeElement')}}
        </el-button>
        <el-button
          type="danger"
          class="TakeNextSubevent"
          :disabled="CloneDisabled.Event||CloneDisabled.disableButton"
          :loading='TakeNextLoad'
          @click="TakeNextSubevent"
          v-if="EventMotionSelect == 1 && CompileType === 'events' && eventDetail.liveStatus == 1 && FeaturesList['Rundown PGM Templates']">
          {{$t('lang.nextSeg')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { mapActions, mapState } from 'vuex'
import { playoutAnalyze, scheduleAnalyze, componentsAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import PublicFileSelect from '@/components/common/PublicFileSelect.vue'
import LogoCrawlSelect from '@/components/file/LogoCrawlSelect.vue'
import CategorySelect from '@/components/select/CategorySelect.vue'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import commonRequest from '@/assets/js/common/commonRequest.js'
import PublicMultipleSelect from '@/components/select/PublicMultipleSelect.vue'
import UploadThumbnail from '@/components/file/UploadThumbnail.vue'
import Output from '@/views/Workbench/Output.vue'
import UndoAction from '@/assets/js/common/UndoAction.js'
import LoopEventTime from '@/components/common/PopupBox/LoopEventTime.vue'
import ActionTip from '@/components/common/PopupBox/ActionTip.vue'
import DurationEdit from '@/components/common/PopupBox/DurationEdit.vue'
import EventsStaticShow from '@/components/common/PopupBox/EventsStaticShow.vue'
import MediaTimeFloor from '@/components/file/MediaTimeFloor.vue'
import FlowicsSelect from '@/components/common/FlowicsSelect.vue'
import {
  EventColorArr,
  WeekDayList
} from '@/assets/js/common/ParamConfig.js'
import {
  Segments,
  LogoConfig,
  ScteType,
  SourceConfigParams,
  keyLogVolue
} from '@/assets/js/temConfig.js'
import FollowOnSelect from './followOnSelect.vue'
import OverVideoTime from '@/components/common/PopupBox/OverVideoTime.vue'

const googleKey = 'playout'
export default {
  props: {
    // 选中的事件
    picthOnEvent: {
      type: Object,
      default: () => ({
        //   新加子事件scte属性
        eventSegments: []
      })
    },
    // 对事件的几种操作
    EventMotion: {
      type: [String, Number],
      default: 1
    }, // 0 展示 1编辑 2创建
    // R的信息
    fixedDevice: Object,
    // 鼠标所点位置
    BoxPosition: {
      type: Object,
      default: () => ({
        top: 500,
        left: 500
      })
    },
    displayType: {
      type: Number,
      default: 0
    },
    displayTab: {
      type: String,
      default: 'note'
    }
  },
  data () {
    return {
      // 保存上一个请求结果不回来不请求下一个
      saveLock: false,
      // 视频时间
      videoTimes: 0,
      // R的版本大于7.6
      Rversions: false,
      // 对事件的几种操作
      EventMotionSelect: 0,
      // 是否copy
      IsCopyEvent: false,
      // 弹出框的一些属性
      FrameProperty: {
        left: 100,
        top: 200
      },
      // 所有事件时间
      AllEventTime: {
        EventStarttime: 0, // 上一次主事件开始时间
        EventTime: 0, // 主事件时间
        VideoTime: 0, // 主视频时间
        SubeventTime: 0 // 子事件时间
      },
      // 事件的详细信息
      eventDetail: {
        record: false,
        sourceType: 0,
        modeType: 1
      },
      //  是note还是device
      CompileType: 'note',
      // 一系列开关
      mostSwitch: {
        // 颜色开关
        ColorShow: false,
        // 选择Source
        BoxSourceList: false,
        // 编辑Delay 延时时间
        editDelay: false,
        // 编辑bit率
        editBit: false,
        // 是否正在执行
        IsProgress: false,
        // pgmEndScte开关
        pgmEndScte: false
      },
      // Features相关控制
      FeaturesList: {
        pgmEndSCTE: false,
        pgmStartSCTE: false,
        'Rundown PGM Templates': false,
        OccasionalOutput: false,
        HoldEventsRundownTemplate: false
      },
      //   颜色选项
      colorArr: EventColorArr,
      // Source查询列表
      SourceList: [],
      // Source查询分页
      SourcePaging: {
        pageNum: 0,
        pageSize: 35,
        condition: '',
        programId: '',
        loadEnd: false
      },
      // source滚动加载
      SourcebindScroll: {
        onScroll: this.getSourceList,
        directive: '.el-scrollbar__wrap',
        distance: 50
      },
      //   子事件是否显示
      subeventSwitch: 1, // 0不显示  1显示但不显示列表 2显示列表
      SubeventTypeSelete: {
        TimeSignalList: []
      },
      // segments类型
      SegmentsType: Segments,
      // ScteSplice类型
      ScteSpliceType: ScteType,
      // logo类型
      logoConfig: LogoConfig,
      // subevent列表
      subeventList: [],
      // UnderplayClip scte一组数量
      UnderplayClipList: {},
      // 编辑时删除的子事件
      DeleteSubeventList: [],
      //   时间选择限制
      pickerDateStart: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}-${date.month}-${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      pickerDateEnd: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}-${date.month}-${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      //   子事件选择限制
      subeventDateLimit: '00:00:00 - 23:01:00',
      // timing文件选择
      bindScroll: {
        loading: false,
        noMore: false,
        onScroll: this.getNextPage,
        directive: '.el-scrollbar__wrap',
        distance: 50
      },
      // 文件滚动加载
      McpObj: {
        pageNum: 1,
        pageSize: 10,
        condition: ''
      },
      // timming文件存的文件夹
      FolderObjectKey: '',
      // timing列表
      mcpTimingList: [],
      // scte时间间隔
      ScteDuration: 0,
      // live source时间
      programDuration: 1800,
      pageMark: '',
      // regin信息
      RegionInfo: {},
      // 时间选择格式
      PickerFormat: {
        Date: 'yyyy-MM-dd',
        Time: 'h:mm:ss A',
        DateTime: 'yyyy-MM-dd h:mm:ss A'
      },
      // 选择的子事件以及开关
      TakeElementObj: {
        switch: false,
        id: '',
        selectId: '',
        message: {}
      },
      // 缩略图列表
      showThumbList: [],
      // crawl列表
      getCrawlList: [],
      // mediaLive选择配置
      MediaLiveParams: '',
      // Media选择配置
      MediaParams: '',
      // live选择配置
      LiveParams: '',
      // mediaLive选择所有配置
      AllConfigParams: {},
      // takeNext加载
      TakeNextLoad: false,
      // 当前正在播放的event
      CurrentPlayoutEvent: '',
      // Program信息
      ProgramItem: {},
      // 组件是否加载
      occasionalOutputMessage: false,
      // 撤回实例
      UndoActionPro: null,
      // 更新event  loading
      updateEventLoading: false,
      // 重复规则
      RepeatTypeList: [
        {
          label: 'DoesNotRepeat',
          value: 0,
          switch: true
        },
        {
          label: 'Daily',
          value: 1,
          switch: true
        },
        {
          label: 'EveryWeekday',
          value: 2,
          switch: true
        },
        {
          label: 'EveryWeekend',
          value: 3,
          switch: false
        },
        {
          label: 'Custom',
          value: 4,
          switch: true
        }],
      // 循环事件信息
      LoopData: {
        recurType: 0, // 原事件循环类型
        CustomTime: 0, // 现循环类型以及显示时间
        isCustom: false, // 是否已选过自定义
        interval: 1, // 第几天
        customType: 1, // 类型
        week: '', // 周几
        monthType: 1, // 月的两种类型
        month: '1', // 月的哪天
        endType: 1, // 结束类型
        end: 0 // 结束时间，次数
      },
      // 自定义循环功能
      RepeatCustom: false,
      // 删除更新循环事件
      LoopDialog: {
        switch: false,
        Operation: 'delete'
      },
      // 第几周的周几显示
      DayWeekList: WeekDayList,
      // 是否HoldEvent模式事件
      IsHoldEvents: false,
      // 切换source
      cutSource: false,
      // 正在播放的源
      bePlayingSource: {
        tpeerid: '',
        fileName: ''
      },
      isAll: false,
      // mode模式类型
      modeTypeList: [{
        label: 'stopAtEndTime',
        value: 0
      }, {
        label: 'stopByTakeNext',
        value: 1
      }],
      // PGMSCTE的信息展示
      PGMScteMessage: {
        PGMTotalTime: '',
        ScteTotalTime: '',
        ScteNumber: 0
      },
      // 冬令时禁止
      daylightSavingTime: false,
      repeatOrigin: '',
      // 是否取整
      MediaIsRound: false,
      // 增加提示是否取整
      MediaTimeFloor: {
        show: false,
        type: 'Event', // 类型是主事件还是子事件
        file: {}, // 文件
        item: {}, // 子事件
        index: 0 // 子事件下标
      },
      // 保存原来的数据
      saveEventDetail: {},
      // follow on选择弹框数据
      followOnDialog: {
        show: false,
        endTime: 0,
        type: 0,
        loading: false
      },
      SingularMessage: {
        flowicsToken: ''
      },
      // 预览的状态
      NewLiveStatus: {
        status: 0
      },
      // 时长锁定
      timeLockSwitch: false,
      // 编辑前的数据
      oldEventMessage: {},
      // 超出视频长度提示
      OverVideoTime: {
        show: false,
        type: 'main', // main 主视频, sub 子视频
        actualTime: 0, // 视频实际时间
        setTime: 0, // 设置的时间
        index: null // 子事件的下标
      },
      // 超出视频长度处理
      EventOverLoop: 0,
      // singular  file
      singularSelectList: [],
      numTimes: 0,
      // 日志列表以及参数
      EventChangeLog: [],
      // 绑定滚动加载
      bindEventLogScroll: {
        onScroll: this.getEventChangeLog,
        distance: 10
      },
      // 参数
      LogParam: {
        programId: '',
        eventId: '',
        pageNum: 1,
        pageSize: 5,
        isNextPage: true
      },
      // 每个属性对应的值
      keyLogVolue: keyLogVolue,
      // 日志加载
      eventLogLoading: false
    }
  },
  components: {
    LogoCrawlSelect,
    CategorySelect,
    PublicMultipleSelect,
    UploadThumbnail,
    Output,
    LoopEventTime,
    ActionTip,
    DurationEdit,
    EventsStaticShow,
    MediaTimeFloor,
    FollowOnSelect,
    FlowicsSelect,
    OverVideoTime
  },
  computed: {
    ...mapState({
      State: (state) => state,
      listFeatures: (state) => state.playout.listFeatures,
      CloneDisabled: (state) => state.playout.CloneDisabled,
      // 用户权限
      UserChannelPermission: (state) => state.playout.UserChannelPermission,
      // 高级配置的某些参数
      AdvancedSetupConfig: (state) => state.playout.AdvancedSetupConfig
    }),
    // 事件由谁什么时候创建
    createEventLog () {
      const Log = this.$t('lang.createEventLog', {
        email: this.eventDetail.email,
        time: Outil.TransitionCurrentTime1(new Date(this.eventDetail.createTime))
      })
      return Log
    }
  },
  watch: {
    // 监听r变化
    fixedDevice () {
      this.closeCreateBox()
    },
    // 监听tab变化
    CompileType (item) {
      if (item == 'events') {
        if (!this.ScteDuration) {
          this.getScteDuration()
        }
        commonRequest.showThumbList().then((res) => {
          this.showThumbList = res
        })
      }
      if (item != 'note') {
        if (!this.RepeatCustom) return
        if (this.LoopData.isCustom) {
          this.TimeTogether(this.LoopData)
        } else {
          this.eventDetail.recurType = 0
          this.LoopData.CustomTime = 0
        }
        this.RepeatCustom = false
      }
    },
    // 监听pgmEnd开关
    listFeatures: {
      handler (val) {
        Object.keys(this.FeaturesList).forEach((key) => {
          if (val.includes(key)) {
            this.FeaturesList[key] = true
          } else {
            this.FeaturesList[key] = false
          }
        })
        if (this.EventMotionSelect != 1) {
          this.IsHoldEvents = this.FeaturesList.HoldEventsRundownTemplate
          this.SecondaryHide()
        }
      },
      immediate: true
    },
    // 行为同步
    'State.BehaviorChange' (data) {
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'userEditUnLock' && data.type == 0) {
        const userId = localStorage.getItem('userId')
        if (userId == data.userId) {
          NotManyEdit.ReleaseHint(Outil.getProgramReceiver('ownerEmail'), this.closeCreateBox)
        }
      } else if (data.action == 'playoutPreviewStatusModule') {
        if (this.picthOnEvent.id == data.playlistEventId) {
          this.CurrentPlayoutEvent = data.playlistSonEventId
        } else {
          this.CurrentPlayoutEvent = ''
        }
        this.JudgeElement()
      } else if (data.action == 'switchEventSource') {
        if (data.eventId == this.picthOnEvent.id) {
          this.getPlayingSource(data.switchEventSourceType)
        }
      }
    },
    'TakeElementObj.selectId' () {
      this.JudgeElement()
    },
    // 监听开始时间变化，修改循环
    'eventDetail.startTime' () {
      if (this.eventDetail.startTime) {
        this.getRepeatTime(this.eventDetail.startTime)
      }
    },
    // 用户权限
    UserChannelPermission: {
      handler (data) {
        if (data == 5) {
          this.CompileType = 'events'
        }
      },
      immediate: true
    },
    displayTab: {
      handler (data) {
        this.CompileType = data || 'note'
      },
      immediate: true
    }
  },
  created () {
    this.EventMotionSelect = this.EventMotion == 0 || this.EventMotion == 1 ? 1 : this.EventMotion
    // 设置弹出框位置
    this.FrameProperty = JSON.parse(JSON.stringify(this.BoxPosition))
    // 获取时间格式
    this.PickerFormat = Outil.getDateTimePickerFormat()
    // 获取program信息
    this.ProgramItem = Outil.getProgramReceiver()
    // 判断是查看还是编辑
    this.estimateOperate()
    this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
    // 获取timing列表
    this.getMcpList()
    this.SeetingTimeSignal()
    this.daylightSavingTime = this.picthOnEvent.daylightSavingTime == 1
    // if (this.displayType) {
    //   this.checkPreviousEvent()
    // }
    if (this.picthOnEvent.tpeerid) {
      this.getMediaVideo(this.picthOnEvent.tpeerid, this.picthOnEvent.ttype)
    }
    this.GetConfigParams()
    if (this.picthOnEvent.liveStatus == 1) {
      this.getPreviewStatus()
    }
    if (this.EventMotionSelect == 2) {
      this.occasionalOutputMessage = true
    }
    // 判断编辑还是创建 赋予是否为Hold模式
    if (this.EventMotionSelect == 1) {
      this.IsHoldEvents = this.eventDetail.holdEventRundownTemplate == 1
    } else {
      this.IsHoldEvents = this.FeaturesList.HoldEventsRundownTemplate
    }
    this.SecondaryHide()
    this.getExtGfx()
    this.getTemplate('init')

    console.log(this.eventDetail)
  },
  mounted () {
    window.addEventListener('unload', this.EditSend)
    if (this.fixedDevice.version) {
      let { version } = this.fixedDevice
      if (this.fixedDevice.version.length > 3) version = this.fixedDevice.version.substr(0, 3)
      if (version >= '7.6') this.Rversions = true
    }
    this.getCurrentPage()
    this.EditSend('add')
    commonRequest.getCrawlList().then((res) => {
      this.getCrawlList = res
    })
    const UndoParam = {
      MaxStep: 5,
      executeCommand: this.Undo
    }
    this.UndoActionPro = new UndoAction(UndoParam)
    this.UndoActionPro.init()
    // 获取新状态
    this.getNewEvent('init')
    // 获取media是否取整
    commonRequest.getMediaIsRound().then((res) => {
      this.MediaIsRound = res
      this.timeLockSwitch = this.AdvancedSetupConfig.fixDurationByDefault
      this.getTimeLock()
    })
    // 获取时间超出是否循环
    commonRequest.getEventOverLoop().then((res) => {
      this.EventOverLoop = res
    })
  },
  methods: {
    ...mapActions('playout', ['getFeatureList']),
    // 录制变化
    recordChange () {
      this.eventDetail.replay = !!this.eventDetail.record
      this.PushUndo()
    },
    getLength (des) {
      return Outil.getByteLength(des)
    },
    singularSelect (item, index) {
      this.subeventList = this.subeventList.filter(v => {
        return (v.blockId != item.blockId) || (v.singularInfoParams.type == 0) || (v.singularInfoParams.type == 2)
      })
      this.UnderplayClipList[item.blockId] = 1
      const singularItem = this.singularSelectList.filter(v => v.subCompositionName == item.singularInfoParams.subCompositionName)
      const payloadList = Object.keys(singularItem[0].payload)
      const testList = ['title', 'text', 'name', 'string']
      this.numTimes = 0
      if (payloadList.length) {
        payloadList.forEach((v, i) => {
          const IsContain = testList.some(value => v.toLowerCase().includes(value))
          if (IsContain) {
            this.numTimes += 1
            const obj = {
              segmentId: item.segmentId,
              eventOperationType: item.eventOperationType,
              blockId: item.blockId,
              flowics: 0,
              fileId: '',
              OffsetIn: item.OffsetIn,
              OffsetOut: item.OffsetOut,
              timingIn: item.timingIn,
              timingInTime: '00:00:00',
              timingOut: item.timingOut,
              timingOutTime: '00:00:00',
              accumulatedProgramTiming: 0,
              suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
              duration: 0,
              black: 0,
              segmentOrder: index + this.numTimes,
              singularInfoParams: {
                subCompositionName: singularItem[0].subCompositionName,
                state: 'in',
                type: 1,
                payloadKey: v,
                payloadValue: singularItem[0].payload[v]
              }
            }
            this.subeventList.splice(index + this.numTimes, 0, obj)
            this.UnderplayClipList[item.blockId] += 1
          }
        })
        item.singularInfoParams.type = this.numTimes ? 0 : 2
      } else {
        item.singularInfoParams.type = 2
      }
    },
    // 获取singular属性信息
    getSingularInfo () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      if (!ProgramId) return
      if (!this.SingularMessage.token) {
        this.$message.info(this.$t('lang.TokenNotExist'))
        return
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/singular/info', {
        iframeToken: this.SingularMessage.token,
        programId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.singularSelectList = result
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 新增flowics
    addFlowics (item, index) {
      const obj = {
        segmentId: item.segmentId,
        eventOperationType: item.eventOperationType,
        blockId: item.blockId,
        flowics: 1,
        fileId: '',
        timingIn: 0,
        timingInTime: '00:00:00',
        timingOut: 0,
        timingOutTime: '00:00:00',
        accumulatedProgramTiming: 0,
        suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
        duration: 0,
        black: 0,
        segmentOrder: index + this.UnderplayClipList[item.blockId]
      }
      this.subeventList.splice(index + this.UnderplayClipList[item.blockId], 0, obj)
      this.UnderplayClipList[item.blockId] += 1
      // 推送操作
      this.PushUndo()
    },
    // 切换segmentId==13子事件的类型
    changeSegment (val) {
      if (val.eventOperationType == 'Flowics') {
        val.blockId = Outil.return32Str()
        this.UnderplayClipList[val.blockId] = 1
        val.iframeToken = this.SingularMessage.flowicsToken
      } else if (val.eventOperationType == 'Singular') {
        val.blockId = Outil.return32Str()
        this.UnderplayClipList[val.blockId] = 1
        // this.getSingularInfo()
      }
      // 推送操作
      this.PushUndo(val.eventOperationType)
    },
    // 获取ExtGfx信息
    getExtGfx () {
      this.axios
        .post(Outil.getUrl('/singular/getSingular'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.SingularMessage = result
            // this.getSingularInfo()
            if (this.SingularMessage.singularStatus == 2 && this.SingularMessage.flowicsToken) {
              if (this.logoConfig.some(v => {
                return v.value == 'Flowics'
              })) return
              this.logoConfig.push({
                value: 'Flowics',
                label: 'Flowics'
              })
            } else {
              if (this.logoConfig.some(v => {
                return v.value == 'Flowics'
              })) {
                this.logoConfig.splice(this.logoConfig.findIndex(item => item.value === 'Flowics'), 1)
              }
            }
            if (!this.SingularMessage.singularStatus) {
              if (this.logoConfig.some(v => {
                return v.value == 'Singular'
              })) return
              this.logoConfig.push({
                value: 'Singular',
                label: 'Singular'
              })
            } else {
              if (this.logoConfig.some(v => {
                return v.value == 'Singular'
              })) {
                this.logoConfig.splice(this.logoConfig.findIndex(item => item.value === 'Singular'), 1)
              }
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch((e) => {
          console.log(e)
        })
    },
    changeMode (type) {
      if (type == 1) {
        this.LoopData.CustomTime = 0
        this.eventDetail.recurType = 0
      }
    },
    checkPreviousEvent (type) {
      this.axios.post(Outil.getUrl('/event/checkPreviousEvent'), {
        programId: this.$BehaviorSyns.getProgramId(),
        currentTime: this.eventDetail.startTime
      })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              this.LoopData.CustomTime = 0
              this.eventDetail.recurType = 0
            } else {
              if (type) {
                this.$alert(this.$t('lang.needCreateEvent'), null, {
                  // dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('lang.GotIt')
                }).catch(() => {})
              }
              this.eventDetail.multipleModelType = false
            }
          } else {
            if (!type) {
              this.eventDetail.multipleModelType = false
            }
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch((res) => {
          console.log(res)
        })
    },
    followOnModeChange (val) {
      if (val) {
        this.checkPreviousEvent(1)
      }
    },
    // duration修改结束
    DurationEditEnd (DurationObject, subevent, index) {
      subevent.durationEdit = false
      if (DurationObject.type == 'end') {
        subevent.accumulatedProgramTiming = typeof DurationObject.duration == 'number' ? DurationObject.duration : subevent.accumulatedProgramTiming
        subevent.timingOut = subevent.timingIn + subevent.accumulatedProgramTiming
        if (subevent.segmentId == 13) {
          this.countOffset(subevent)
        }
        if (subevent.segmentId == 1) {
          this.countReferenceMedia()
        } else if (subevent.segmentId == 4 || subevent.segmentId == 5 || subevent.segmentId == 10 || ((subevent.segmentId == 2 || subevent.segmentId == 11 || subevent.segmentId == 14) && subevent.eventOperationType != 'Scte only')) {
          this.OtherVideoOvertime(subevent, index)
          // const MediaDuration = subevent.timingOut - subevent.timingIn
          // if (subevent.sonEventMediaDuration && MediaDuration > subevent.sonEventMediaDuration) {
          //   subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
          //   this.$message.info(this.$t('lang.mediaTimeOverstep'))
          // }
        }
        this.SegmentTimeFormat()
        // 推送操作
        this.PushUndo()
      }
    },
    // duration编辑弹窗
    DurationEditShow (index) {
      this.subeventList.forEach((item, index1) => {
        if (index == index1) {
          item.durationEdit = !item.durationEdit
        } else {
          item.durationEdit = false
        }
      })
    },
    // 切换主备源
    CutMediaSource () {
      if (this.CloneDisabled.Event || this.CloneDisabled.disableButton) return
      this.cutSource = true
      this.axios.post(Outil.getUrl('/event/switchMainSecondarySource'), {
        programId: this.$BehaviorSyns.getProgramId(),
        eventId: this.eventDetail.id
      })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.getTakeNextSubevent()
            this.$message({ type: 'success', message: this.$t('lang.success') })
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.cutSource = false
        }).catch(() => {
          this.cutSource = false
        })
    },
    // 重复类型变化
    RepeatTypeChange (key) {
      this.eventDetail.recurType = key
      this.LoopData.CustomTime = key
      if (key > 0) {
        this.eventDetail.editType = 1
      }
      if (key == 4) {
        this.RepeatCustom = true
      } else {
        this.RepeatCustom = false
      }
      // 推送操作
      this.PushUndo()
    },
    // 获取重复是周末还是周一到周五
    getRepeatTime (startTime) {
      const day = new Date(startTime).getDay()
      if (day != 0 && day != 6) {
        this.RepeatTypeList[2].switch = true
        this.RepeatTypeList[3].switch = false
      } else {
        this.RepeatTypeList[2].switch = false
        this.RepeatTypeList[3].switch = true
      }
    },
    // 自定义选择完成
    CustomTimeSelect (data) {
      if (data.type == 0) {
        this.eventDetail.recurType = 0
        this.LoopData.CustomTime = 0
        if (this.LoopData.isCustom) {
          this.TimeTogether(this.LoopData)
        }
      } else {
        this.LoopData.isCustom = true
        this.LoopData = {
          recurType: this.LoopData.recurType,
          CustomTime: this.LoopData.CustomTime,
          isCustom: true,
          ...data.TimeShow
        }
        this.TimeTogether(data.TimeShow)
      }
      this.RepeatCustom = false
      // 推送操作
      this.PushUndo()
    },
    // 类型赋值
    TimeTogether (data) {
      if (!data) return
      let front = ''
      let behind = ''
      if (data.customType == 1) {
        front = data.interval > 1 ? this.$t('lang.EveryFewDays', { number: data.interval }) : this.$t('lang.Daily')
      } else if (data.customType == 2) {
        const WeekList = data.week.split(',').sort()
        let weeks = ''
        WeekList.forEach((item, index) => {
          const week = this.DayWeekList[1][Number(item) - 1]
          if (index) {
            weeks += `, ${this.$t(`lang.${week}`)}`
          } else {
            weeks = this.$t(`lang.${week}`)
          }
        })
        front = data.interval > 1 ? this.$t('lang.EveryFewWeeks', { number: data.interval, week: weeks }) : this.$t('lang.AWeekAFew', { week: weeks })
      } else if (data.customType == 3) {
        if (data.monthType == 1) {
          const SeveralFew = {
            day: Number(data.month)
          }
          front = data.interval > 1 ? this.$t('lang.EveryMonthlyDay', { number: data.interval, day: SeveralFew.day }) : this.$t('lang.MonthlyDay', { day: SeveralFew.day })
        } else if (data.monthType == 2) {
          const month = data.month.split(',')
          const SeveralFew = {
            number: Number(month[0]),
            week: Number(month[1])
          }
          const FirstWeek = {
            first: this.DayWeekList[0][SeveralFew.number - 1],
            week: this.DayWeekList[1][SeveralFew.week - 1]
          }
          front = data.interval > 1 ? this.$t('lang.EveryMonthlyFirstWeeks', { number: data.interval, first: this.$t(`lang.${FirstWeek.first}`), week: this.$t(`lang.${FirstWeek.week}`) }) : this.$t('lang.MonthlyFirstWeeks', { first: this.$t(`lang.${FirstWeek.first}`), week: this.$t(`lang.${FirstWeek.week}`) })
        }
      }
      if (data.endType == 2) {
        const time = Outil.changeNewDate(data.end, 1)
        behind = this.$t('lang.UntilTime', { time: time })
      } else if (data.endType == 3) {
        behind = this.$t('lang.HowTimes', { times: data.end })
      }
      this.LoopData.CustomTime = front + behind
    },
    // 接收撤回消息
    Undo (data) {
      let item = ''
      this.occasionalOutputMessage = false
      Object.keys(data).forEach((key) => {
        try {
          item = JSON.parse(data[key])
        } catch (error) {}
        if (typeof item == 'object') {
          this._data[key] = item
        } else {
          this._data[key] = data[key]
        }
      })
      this.$nextTick(() => {
        this.occasionalOutputMessage = true
      })
    },
    // 发送行为消息
    PushUndo (type) {
      const PreviousAction = {}
      const key = (type == 'input' || type == 'inputEnd') ? type : ''
      PreviousAction.CompileType = this.CompileType
      PreviousAction.IsCopyEvent = this.IsCopyEvent
      PreviousAction.EventMotionSelect = this.EventMotionSelect
      PreviousAction.eventDetail = JSON.stringify(this.eventDetail)
      PreviousAction.subeventList = JSON.stringify(this.subeventList)
      PreviousAction.DeleteSubeventList = JSON.stringify(this.DeleteSubeventList)
      PreviousAction.UnderplayClipList = JSON.stringify(this.UnderplayClipList)
      PreviousAction.RepeatCustom = this.RepeatCustom
      PreviousAction.LoopData = JSON.stringify(this.LoopData)
      if (type == 'clearUndo') {
        this.UndoActionPro.clearUndo(PreviousAction)
      } else {
        this.UndoActionPro.pushUndo(PreviousAction, key)
      }
    },
    // 切换tab
    CutTab (key) {
      if (this.CompileType != key) {
        this.CompileType = key
        this.PushUndo()
        if (this.CompileType == 'changeLog') this.getEventChangeLog('init')
      }
    },
    // 获取更新事件日志信息
    getEventChangeLog (Type) {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.LogParam.programId = ProgramId
      this.LogParam.eventId = this.eventDetail.id
      if (Type == 'init') {
        this.LogParam.pageNum = 1
        this.LogParam.isNextPage = true
        this.eventLogLoading = true
      } else if (this.LogParam.isNextPage) {
        this.LogParam.pageNum++
      } else {
        return
      }
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/changeLog'),
        data: this.LogParam
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result ? res.data.result : {}
          const LogList = this.ChangeLogData(result.updates)
          if (this.LogParam.pageNum == 1) {
            this.EventChangeLog = LogList
          } else {
            this.EventChangeLog.push(...LogList)
          }
          if (result.create && result.updates && result.updates.length < 5) {
            this.LogParam.isNextPage = false
            this.EventChangeLog.push({
              eventType: 'Event',
              type: 2,
              email: result.create.email,
              updateTime: Outil.TransitionCurrentTime1(new Date(result.create.timestamp)),
              showType: 'create'
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
        this.eventLogLoading = false
      }).catch(() => {
        this.eventLogLoading = false
      })
    },
    // 日志数据处理
    ChangeLogData (list) {
      const ChangeLogData = []
      list.forEach((item) => {
        const LogItem = item.eventChangeLogList ? item.eventChangeLogList : []
        LogItem.forEach((item1) => {
          const Log = JSON.parse(JSON.stringify(item1))
          Log.updateTime = Outil.TransitionCurrentTime1(new Date(item.timestamp))
          Log.email = item.email
          if (['multipleModelType', 'pgmStartScte', 'pgmStartScte', 'pgmEndScte', 'record', 'replay'].includes(Log.key)) {
            Log.showType = 'switch'
            Log.oldValue = Number(Log.oldValue)
            Log.newValue = Number(Log.newValue)
          } else if (['eventModelType', 'recurType'].includes(Log.key)) {
            Log.showType = 'select'
            Log.oldValue = Number(Log.oldValue)
            Log.newValue = Number(Log.newValue)
          } else if (['startTime', 'endTime'].includes(Log.key)) {
            Log.showType = 'time'
            Log.oldValue = Number(Log.oldValue)
            Log.newValue = Number(Log.newValue)
          }
          ChangeLogData.push(Log)
        })
      })
      return ChangeLogData
    },
    // 通过判断显示数据内容
    ShowLogData (data) {
      let writeText = ''
      if (data.eventType == 'Event') {
        if (data.showType == 'create') {
          writeText = this.$t('lang.logCreateEvent')
        } else {
          const key = this.keyLogVolue[data.key] ? this.$t(this.keyLogVolue[data.key]) : data.key
          let oldValue = data.oldValue === null ? '' : data.oldValue
          let newValue = data.newValue === null ? '' : data.newValue
          if (data.showType == 'switch') {
            oldValue = oldValue ? this.$t('lang.On') : this.$t('lang.Off')
            newValue = newValue ? this.$t('lang.On') : this.$t('lang.Off')
          } else if (data.showType == 'select') {
            if (data.key == 'eventModelType') {
              const oldLabel = this.modeTypeList[oldValue] ? this.modeTypeList[oldValue].label : ''
              const newLabel = this.modeTypeList[newValue] ? this.modeTypeList[newValue].label : ''
              oldValue = this.$t(`lang.${oldLabel}`)
              newValue = this.$t(`lang.${newLabel}`)
            } else if (data.key == 'recurType') {
              const oldLabel = this.RepeatTypeList[oldValue] ? this.RepeatTypeList[oldValue].label : ''
              const newLabel = this.RepeatTypeList[newValue] ? this.RepeatTypeList[newValue].label : ''
              oldValue = this.$t(`lang.${oldLabel}`)
              newValue = this.$t(`lang.${newLabel}`)
            }
          } else if (data.showType == 'time') {
            oldValue = Outil.TransitionCurrentTime1(new Date(oldValue))
            newValue = Outil.TransitionCurrentTime1(new Date(newValue))
          }
          writeText = this.$t('lang.logChangeEvent', {
            key,
            oldValue,
            newValue
          })
        }
      } else if (data.eventType == 'SonEvent') {
        const keyItem = Segments.filter((item) => {
          return item.value == data.key
        })
        const key = keyItem[0] ? this.$t(`lang.${keyItem[0].label}`) : ''
        if (data.type == 1) {
          writeText = this.$t('lang.logAddSonevent', { key })
        } else if (data.type == 2) {
          writeText = this.$t('lang.logChangeSonevent', { key })
        } else if (data.type == 3) {
          writeText = this.$t('lang.logDeleteSonevent', { key })
        }
      }
      return writeText
    },
    AccountSelectInfo (val) {
      this.eventDetail.occasionalOutputMessage = JSON.parse(JSON.stringify(val))
      // 推送操作
      this.PushUndo()
    },
    // pgmStart关闭清除数据
    pgmStartScteChange () {
      // this.eventDetail.pgmStartSourceId = ''
      // this.eventDetail.pgmStartSourceName = ''
      // 推送操作
      this.PushUndo()
    },
    // 缩略图赋值
    ThumbnailSelectChange (key) {
      this.eventDetail.thumbnail = key
      // 推送操作
      this.PushUndo()
    },
    getStorage () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/storage'),
        data: {
          programId: ProgramId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (result.enableExternalS3) {
              this.SettingParams('update')
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取多选择组件配置
    GetConfigParams () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.AllConfigParams = SourceConfigParams(programId, this.RegionInfo.bucket)
      this.getStorage()
      this.SettingParams()
    },
    // 设置显示参数
    SettingParams (type) {
      if (type == 'update') {
        this.MediaLiveParams = {
          List: {
            Live: this.AllConfigParams.Live,
            Media: this.AllConfigParams.Media,
            AmazonS3: this.AllConfigParams.AmazonS3
          },
          search: this.AllConfigParams.search
        }
        this.MediaParams = {
          List: {
            Media: this.AllConfigParams.Media,
            AmazonS3: this.AllConfigParams.AmazonS3
          },
          search: this.AllConfigParams.search
        }
      } else {
        this.MediaLiveParams = {
          List: {
            Live: this.AllConfigParams.Live,
            Media: this.AllConfigParams.Media
          },
          search: this.AllConfigParams.search
        }
        this.MediaParams = {
          List: {
            Media: this.AllConfigParams.Media
          },
          search: this.AllConfigParams.search
        }
      }
      this.LiveParams = {
        List: {
          Live: this.AllConfigParams.Live
        },
        search: this.AllConfigParams.search
      }
    },
    // 切换下一个子事件
    TakeNextSubevent () {
      if (!this.eventDetail.id) {
        this.$message.info(this.$t('lang.eventIdNot'))
        return
      }
      this.TakeNextLoad = true
      this.axios.post(Outil.getUrl('/event/takeNextSonEvent'), {
        programId: this.$BehaviorSyns.getProgramId(),
        eventId: this.eventDetail.id
      },
      {
        timeout: 60000
      })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$BehaviorSyns.SendBehavior('EventListChange', 1)
            this.getTakeNextSubevent()
          } else {
            this.TakeNextLoad = false
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
          this.TakeNextLoad = false
        })
    },
    // 获取新消息
    getTakeNextSubevent () {
      this.axios.post(Outil.getUrl('/event/getEventById'), {
        eventId: this.eventDetail.id
      },
      {
        timeout: 60000
      })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.TakeNextLoad = false
            const event = res.data.result
            this.estimateOperate('update', event)
            this.PushUndo('clearUndo')
          } else {
            this.TakeNextLoad = false
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
          this.TakeNextLoad = false
        })
    },
    // 获取新的事件信息
    getNewEvent (type) {
      if (!this.eventDetail.id) {
        // 推送操作
        if (type == 'init') this.PushUndo()
        return
      }
      this.updateEventLoading = true
      this.axios.post(Outil.getUrl('/event/getEventById'), {
        eventId: this.eventDetail.id
      })
        .then((res) => {
          this.updateEventLoading = false
          if (res.data.errorCode == '0x0') {
            const event = res.data.result
            if (event.highlightEvent) {
              this.TakeElementObj.selectId = event.highlightEvent
              this.TakeElementObj.switch = true
            }
            if (type == 'init') {
              // this.$set(this.eventDetail, 'pgmStartSourceName', event.pgmStartSourceName)
              // this.$set(this.eventDetail, 'occasionalOutputMessage', event.occasionalOutputMessage)
              // this.$set(this.eventDetail, 'recurType', event.recurType)
              // this.$set(this.eventDetail, 'switchEventSourceType', event.switchEventSourceType)
              // this.$set(this.eventDetail, 'tname', event.tname)
              // this.$set(this.eventDetail, 'secondaryTname', event.secondaryTname)
              this.estimateOperate('init', event)
              this.LoopData.recurType = event.recurType
              if (event.recurType == 4) {
                this.LoopData.isCustom = true
                Object.assign(this.LoopData, event.custom)
                this.TimeTogether(this.LoopData)
              } else {
                this.LoopData.CustomTime = event.recurType
              }
              this.getPlayingSource(event.switchEventSourceType)
              this.occasionalOutputMessage = true
              // 推送操作
              this.PushUndo()
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
          this.updateEventLoading = false
        })
    },
    // 正在播放的源处理
    getPlayingSource (switchEventSourceType) {
      this.eventDetail.switchEventSourceType = switchEventSourceType
      if (switchEventSourceType) {
        this.bePlayingSource = {
          tpeerid: this.eventDetail.secondaryTpeerid,
          fileName: this.eventDetail.secondaryTname
        }
      } else {
        this.bePlayingSource = {
          tpeerid: this.eventDetail.tpeerid,
          fileName: this.eventDetail.tname
        }
      }
    },
    // 切换播放子事件
    TakeElement () {
      if (this.eventDetail.liveStatus != 1) {
        this.$message(this.$t('lang.OnlyLiveUse'))
        return
      }
      const subevent = this.TakeElementObj.message
      const param = {
        currentEventId: this.eventDetail.id,
        sonEventId: subevent.id,
        sourceId: subevent.sourceId,
        duration: subevent.timingOut - subevent.timingIn,
        sourceType: 0
      }
      if (subevent.segmentId == 1) {
        param.sourceId = this.eventDetail.tpeerid
        param.sourceType = this.eventDetail.sourceType
      }
      if (!param.sourceId) {
        this.$message(this.$t('lang.MediaOrSource'))
        return
      }
      if (this.TakeElementObj.id) {
        this.axios.post(Outil.getUrl('/event/takeElement'), param, {
          timeout: 120000
        })
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.getNewEvent()
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      } else {
        this.$message(this.$t('lang.TakeSelectElement'))
      }
    },
    // 选择子事件
    SelectTakeElement (subevent) {
      if (subevent.id && this.eventDetail.liveStatus == 1) {
        this.TakeElementObj.id = subevent.id
        this.TakeElementObj.message = subevent
      }
    },
    // 标签选择
    categoryChange (value) {
      this.eventDetail.category = value
      // 推送操作
      this.PushUndo()
    },
    // Secondary类型功能显示隐藏
    SecondaryHide () {
      const List = JSON.parse(JSON.stringify(this.SegmentsType))
      if (this.IsHoldEvents) {
        List[8].isShow = false
      } else {
        List[8].isShow = true
      }
      this.SegmentsType = List
    },
    // 设置TimeSignal选项的
    SeetingTimeSignal () {
      const ProgramRMessage = Outil.getProgramReceiver()
      const List = JSON.parse(JSON.stringify(this.SegmentsType))
      if (ProgramRMessage.scteType) {
        List[2].isShow = false
      } else {
        List[3].isShow = false
      }
      this.SegmentsType = List
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/scte'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            Object.keys(result.timeSignalScte).forEach(key => {
              this.SubeventTypeSelete.TimeSignalList.push({
                value: key,
                label: key,
                key: result.timeSignalScte[key]
              })
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 在编辑add、取消编辑close,浏览器关闭 空
    EditSend (type) {
      const param = {
        logicId: this.picthOnEvent.id,
        type: 0
      }
      if (type == 'add') {
        param.pid = this.$BehaviorSyns.getProgramId()
        param.name = this.picthOnEvent.title
        NotManyEdit.AddEdit(param)
      } else if (type == 'close') {
        NotManyEdit.QuitEdit(param)
      } else {
        NotManyEdit.CloseQuitEdit(param)
      }
    },
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 获取media的信息
    getMediaVideo (sourceId, type) {
      if (['video', 'file', 'json'].includes(type)) {
        this.axios.post(Outil.getUrl(`/fileInfoNew/getFileInfoBySourceId?sourceId=${sourceId}`))
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.videoTimes = Math.floor(res.data.result.videoTimes ? res.data.result.videoTimes : 0)
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      } else {
        this.videoTimes = 30 * 60
      }
    },
    // 获取scte时间间隔
    getScteDuration () {
      if (!this.picthOnEvent.templateId) {
        this.ScteDuration = 90
        return
      }
      this.axios.post(Outil.getUrl('/eventTemplate/getById'), {
        id: this.picthOnEvent.templateId
      })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              const data = res.data.result
              this.ScteDuration = data.scteSpliceDurationDefault
              let programDuration = 1800
              if (data.overUnderTime >= 0) {
                programDuration = data.templateVideoTotalTime - data.overUnderTime
              } else {
                programDuration = data.templateVideoTotalTime
              }
              if (data.eventSegments && data.eventSegments[0]) {
                if (data.eventSegments[0].segmentId == 6) {
                  programDuration = programDuration - data.eventSegments[0].accumulatedProgramTiming
                }
              }
              this.programDuration = programDuration
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
    },
    // 处理子事件没有name问题
    SetSubeventName (item) {
      let Name = item.eventOperationType
      if (!Name) {
        const SegmentsItem = this.SegmentsType.filter(
          (m) => m.value == item.segmentId
        )
        Name = SegmentsItem[0].label
      }
      return Name
    },
    // 更改创建开始时间
    changeStartTime (val) {
      // 如果开始时间小于当前时间  一般不会有这种情况
      if (val <= new Date().getTime()) {
        this.eventDetail.startTime = null
        this.$message.error(this.$t('lang.startTimeMoreCurTime'))
        return
      }
      //   编辑的时候
      if ((this.EventMotionSelect == 1 && this.eventDetail.timeLock == 1) || (this.EventMotionSelect == 2 && this.IsCopyEvent)) {
        const durTime = this.AllEventTime.EventTime
        this.eventDetail.endTime = this.eventDetail.startTime + durTime
      }

      if (this.eventDetail.endTime && this.eventDetail.endTime - val < 0) {
        this.$message.error(this.$t('lang.endTimeMoreStartTime'))
      }
      this.setSubeventDateLimit()
      if (!this.IsHoldEvents) {
        this.countReferenceMedia(this.eventDetail.eventMediaDuration, 'main')
      }
      // 推送操作
      this.PushUndo()
    },
    // 更改创建结束时间
    changeEndTime (val) {
      // 如果结束时间小于当前时间  一般不会有这种情况
      if (val < new Date().getTime()) {
        this.eventDetail.endTime = this.eventDetail.startTime +
        this.$message.error(this.$t('lang.endTimeMoreCurTime'))
        return
      }
      //   编辑的时候
      if ((this.EventMotionSelect == 1 && this.eventDetail.timeLock == 1) || (this.EventMotionSelect == 2 && this.IsCopyEvent)) {
        const durTime = this.AllEventTime.EventTime
        this.eventDetail.startTime = this.eventDetail.endTime - durTime
      }

      if (
        this.eventDetail.endTime && this.eventDetail.endTime - this.eventDetail.startTime < 0
      ) {
        this.$message.error(this.$t('lang.endTimeMoreStartTime'))
      }
      this.setSubeventDateLimit()
      if (!this.IsHoldEvents) {
        this.countReferenceMedia(this.eventDetail.eventMediaDuration, 'main')
      }
      // 推送操作
      this.PushUndo()
    },
    // 获取是否锁定
    getTimeLock () {
      if (this.timeLockSwitch && this.eventDetail.timeLock == 0) {
        this.eventDetail.timeLock = 1
      }
    },
    // 时长锁定
    timeLock () {
      this.eventDetail.timeLock = this.eventDetail.timeLock == 1 ? 2 : 1
      // 推送操作
      this.PushUndo()
    },
    // 清楚主源备用源
    clearMessage (type) {
      if (type == 1) {
        this.eventDetail.tname = ''
        this.eventDetail.tpeerid = ''
        this.eventDetail.ttype = ''
        this.eventDetail.fileId = ''
        this.eventDetail.eventMediaDuration = 0
      } else {
        this.eventDetail.secondaryTname = ''
        this.eventDetail.secondaryTpeerid = ''
        this.eventDetail.secondaryTtype = ''
      }
      // 推送操作
      this.PushUndo()
    },
    // 第一视频选择
    MediaLivePrimaryChange (pitchOnFile) {
      // 判断是media还是Live Source
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        if (pitchOnFile.peerId) {
          pitchOnFile.sourceId = pitchOnFile.peerId
        }
        this.eventDetail.record = !!this.AdvancedSetupConfig.defaultSecondaryRecord
        this.eventDetail.replay = this.eventDetail.record
        this.SelectSource(pitchOnFile)
      } else {
        const videoTimes = pitchOnFile.videoTimes ? Number(pitchOnFile.videoTimes) : 0
        pitchOnFile.videoTimes = videoTimes
        // 判断是否是浮点数
        if (parseInt(videoTimes) !== videoTimes) {
          // 判断是否需要取整
          if (this.MediaIsRound) {
            pitchOnFile.videoTimes = Math.floor(videoTimes)
          } else {
            this.MediaTimeFloor.show = true
            this.MediaTimeFloor.file = pitchOnFile
            this.MediaTimeFloor.type = 'Event'
            return
          }
        }
        this.eventDetail.record = false
        this.eventDetail.replay = this.eventDetail.record
        this.fileSeleteChange(pitchOnFile, 1)
      }
    },
    // 取整选择结果
    RoundSelectRes (value) {
      const pitchOnFile = this.MediaTimeFloor.file
      if (value == 1) {
        pitchOnFile.videoTimes = Math.floor(pitchOnFile.videoTimes)
      }
      if (this.MediaTimeFloor.type == 'Event') {
        this.fileSeleteChange(pitchOnFile, 1)
      } else if (this.MediaTimeFloor.type == 'sonEvent') {
        const item = this.MediaTimeFloor.item
        const index = this.MediaTimeFloor.index
        this.SubeventFileSelect(pitchOnFile, item, index)
      }
    },
    // 备用视频选择
    MediaLiveSecondaryChange (pitchOnFile) {
      if (pitchOnFile.peerId) {
        pitchOnFile.sourceId = pitchOnFile.peerId
      }
      this.eventDetail.secondaryTname = pitchOnFile.name
      this.eventDetail.secondaryTpeerid = pitchOnFile.sourceId
      this.eventDetail.secondaryTtype = pitchOnFile.type
      // 判断是media还是Live Source
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        this.eventDetail.secondarySourceType = 1
      } else {
        this.eventDetail.secondarySourceType = 0
      }
      // 推送操作
      this.PushUndo()
    },
    // 子事件Live与media选择
    SubeventFileDispose (pitchOnFile, item, index) {
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        this.SubeventFileSelect(pitchOnFile, item, index)
      } else {
        const videoTimes = pitchOnFile.videoTimes ? Number(pitchOnFile.videoTimes) : 0
        pitchOnFile.videoTimes = videoTimes
        // 判断是否是浮点数
        if (parseInt(videoTimes) !== videoTimes) {
          // 判断是否需要取整
          if (this.MediaIsRound) {
            pitchOnFile.videoTimes = Math.floor(videoTimes)
          } else {
            this.MediaTimeFloor.show = true
            this.MediaTimeFloor.file = pitchOnFile
            this.MediaTimeFloor.item = item
            this.MediaTimeFloor.index = index
            this.MediaTimeFloor.type = 'sonEvent'
            return
          }
        }
        this.SubeventFileSelect(pitchOnFile, item, index)
      }
    },
    // 子事件文件选择
    SubeventFileSelect (pitchOnFile, item, index) {
      let videoTimes = 0
      // 判断是media还是Live Source
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        if (pitchOnFile.peerId) {
          pitchOnFile.sourceId = pitchOnFile.peerId
        }
        videoTimes = 30 * 60 * 1000
        item.fileId = ''
        item.sonEventMediaDuration = 0
      } else {
        videoTimes = pitchOnFile.videoTimes
        videoTimes = videoTimes * 1000
        this.$set(item, 'fileId', pitchOnFile.id)
        item.sonEventMediaDuration = videoTimes
      }
      if (!item.timingIn) {
        let lastEvent = -1
        if (this.subeventList.length) {
          lastEvent = this.subeventList[index - 1]
        }
        const timingIn = lastEvent != -1 ? lastEvent.timingOut : this.eventDetail.startTime
        item.ShowTimingIn = Outil.changeNewTime(timingIn)
        item.timingIn = timingIn
      }
      item.sourceId = pitchOnFile.sourceId
      item.fileType = pitchOnFile.type
      item.timingOut = item.timingIn + videoTimes
      item.accumulatedProgramTiming = item.timingOut - item.timingIn
      item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
      item.fileName = pitchOnFile.name
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 子事件文件信息清除
    SubeventClearMessage (item) {
      item.sourceId = ''
      item.fileType = ''
      item.fileName = ''
      item.fileId = ''
      item.sonEventMediaDuration = 0
      // 推送操作
      this.PushUndo()
    },
    // 文件选择变化
    fileSeleteChange (pitchOnFile, item, index) {
      // 主文件选择
      if (item === 1) {
        this.eventDetail.sourceType = 0
        this.eventDetail.tname = pitchOnFile.name
        this.eventDetail.tpeerid = pitchOnFile.sourceId
        this.eventDetail.ttype = pitchOnFile.type
        this.eventDetail.fileId = pitchOnFile.id
        let videoTimes = pitchOnFile.videoTimes
        this.videoTimes = videoTimes
        videoTimes = videoTimes * 1000
        this.eventDetail.eventMediaDuration = videoTimes
        this.TimeReferenceMedia(videoTimes)
        // this.$set(this.eventDetail, 'tpeerid', pitchOnFile.sourceId);
      } else if (item === 2) {
        // SCTEPGMStart视频选择
        // this.eventDetail.pgmStartSourceId = pitchOnFile.sourceId
        // this.eventDetail.pgmStartSourceName = pitchOnFile.name
      }
      // 推送操作
      this.PushUndo()
    },
    // LogoCraw选择变化
    LogoCrawlChange (pitchOnFile, item) {
      item.fileName = pitchOnFile.name
      this.$set(item, 'fileId', pitchOnFile.fileId)
      // 推送操作
      this.PushUndo()
    },
    // 计算子事件Reference Media时间
    countReferenceMedia (sourceDuration, type) {
      // media总时长
      let MediaTotalDuration = 0
      this.subeventList.forEach((item) => {
        if (item.segmentId === 1) {
          const eventDuration = item.timingOut - item.timingIn
          MediaTotalDuration += eventDuration
        }
      })
      // 主时间变化时
      if (type === 'main') {
        const length = this.subeventList.length
        if (length === 0) return
        const timeRemaining = this.eventDetail.endTime - this.subeventList[length - 1].timingOut
        let addMediatotal = MediaTotalDuration + timeRemaining
        addMediatotal = addMediatotal <= 0 ? 0 : addMediatotal
        if (!this.eventDetail.sourceType && this.eventDetail.eventMediaDuration && addMediatotal > this.eventDetail.eventMediaDuration) {
          // this.TimeReferenceMedia(this.eventDetail.eventMediaDuration)
          // this.$message.info(this.$t('lang.mediaTimeOverstep'))
          // console.log('111111111')
          this.MainVideoOvertime(this.eventDetail.eventMediaDuration, addMediatotal)
          return
        }
        this.TimeReferenceMedia(addMediatotal)
        return
      }
      // 类型为Media时，时间变化
      if (!this.eventDetail.sourceType && this.eventDetail.eventMediaDuration && MediaTotalDuration > this.eventDetail.eventMediaDuration) {
        // this.TimeReferenceMedia(this.eventDetail.eventMediaDuration)
        // this.$message.info(this.$t('lang.mediaTimeOverstep'))
        this.MainVideoOvertime(this.eventDetail.eventMediaDuration)
      } else if (this.eventDetail.sourceType && MediaTotalDuration == 0 && sourceDuration) {
        // 类型为Live并且Reference Media为0时，更新
        this.TimeReferenceMedia(sourceDuration)
      }
    },
    // 主视频选择时间超出视频时间
    MainVideoOvertime (actualTime, setTime) {
      if (this.EventOverLoop === 1) {
        if (setTime) this.TimeReferenceMedia(setTime)
      } else if (this.EventOverLoop === 2) {
        if (actualTime) this.TimeReferenceMedia(actualTime)
      } else {
        this.OverVideoTime = {
          show: true,
          type: 'main',
          actualTime,
          setTime
        }
      }
      // this.$confirm(this.$t('lang.OvertimeLoop'), '', {
      //   confirmButtonText: this.$t('lang.Confirm'),
      //   cancelButtonText: this.$t('lang.cancel'),
      //   dangerouslyUseHTMLString: true
      // }).then(() => {
      //   if (setTime) this.TimeReferenceMedia(setTime)
      // }).catch(() => {
      //   if (actualTime) this.TimeReferenceMedia(actualTime)
      // })
    },
    // 其他视频选择时间超出视频时间
    OtherVideoOvertime (subevent, index) {
      const MediaDuration = subevent.timingOut - subevent.timingIn
      if (subevent.sonEventMediaDuration && MediaDuration > subevent.sonEventMediaDuration) {
        if (this.EventOverLoop === 2) {
          subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
          // 子事件时间格式化
          this.SegmentTimeFormat()
        } else if (this.EventOverLoop != 1) {
          this.OverVideoTime = {
            show: true,
            type: 'sub',
            index
          }
        }
        // this.$confirm(this.$t('lang.OvertimeLoop'), '', {
        //   confirmButtonText: this.$t('lang.Confirm'),
        //   cancelButtonText: this.$t('lang.cancel'),
        //   dangerouslyUseHTMLString: true
        // }).then(() => {}).catch(() => {
        //   subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
        //   // 子事件时间格式化
        //   this.SegmentTimeFormat()
        // })
      }
    },
    // 超出时间选择结果
    OverTimeSelect (OverTime) {
      if (this.OverVideoTime.type === 'main') {
        if (OverTime.ExtendTime === 1 && this.OverVideoTime.setTime) {
          this.TimeReferenceMedia(this.OverVideoTime.setTime)
        } else if (!OverTime.ExtendTime && this.OverVideoTime.actualTime) {
          this.TimeReferenceMedia(this.OverVideoTime.actualTime)
        }
      } else if (this.OverVideoTime.type === 'sub') {
        if (OverTime.ExtendTime === 2 && this.OverVideoTime.index != null) {
          const subevent = this.subeventList[this.OverVideoTime.index]
          subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
          // 子事件时间格式化
          this.SegmentTimeFormat()
        }
      }
      if (OverTime.NoAgainAsk) {
        this.EventOverLoop = OverTime.ExtendTime
        commonRequest.setEventOverLoop(this.ProgramItem.ProgramId, OverTime.ExtendTime)
      }
    },
    // 根据时间增加删除Reference Media
    TimeReferenceMedia (videoTime) {
      const obj = {
        segmentId: 1,
        segmentOrder: 0,
        SerialNumber: 1,
        ShowTimingIn: '',
        timingIn: 0,
        ShowTimingOut: '',
        timingOut: 0,
        accumulatedProgramTiming: 0,
        durationEdit: false
      }
      const EventLength = this.subeventList.length
      if (this.IsHoldEvents) {
        if (EventLength == 0) {
          this.subeventList.push(obj)
          this.SegmentTimeFormat()
        }
        return
      }
      if (EventLength > 0) {
        let timeLeft = videoTime
        let LastMedia = null
        for (let i = 0; i < EventLength; i++) {
          const item = this.subeventList[i]
          if (!item || item.segmentId !== 1) {
            continue
          }
          const eventDuration = item.timingOut - item.timingIn
          if (timeLeft == 0) {
            this.subeventList.splice(i, 1)
            i--
          } else if (eventDuration >= timeLeft) {
            item.timingOut = item.timingIn + timeLeft
            timeLeft = 0
          } else if (eventDuration < timeLeft) {
            timeLeft -= eventDuration
          }
          LastMedia = item
        }
        if (timeLeft > 0) {
          if (LastMedia) {
            LastMedia.timingOut = LastMedia.timingOut + timeLeft
          } else if (this.subeventList[EventLength - 1].segmentId == 7) {
            obj.segmentOrder = EventLength - 1
            obj.timingOut = obj.timingIn + timeLeft
            this.subeventList.splice(EventLength - 1, 0, obj)
          } else {
            obj.segmentOrder = EventLength
            obj.timingOut = obj.timingIn + timeLeft
            this.subeventList.push(obj)
          }
        }
      } else {
        obj.timingOut = obj.timingIn + videoTime
        this.subeventList.push(obj)
      }
      this.SegmentTimeFormat()
    },
    // 子事件时间格式化
    SegmentTimeFormat (timeLock) {
      if (this.subeventList.length <= 0) {
        this.PGMScteMessage.PGMTotalTime = ''
        return
      }
      let parent = {}
      let lastEvent = {}
      let maxTime = 0
      // PGMSCTE的信息展示
      const ScteMessage = {
        maxTime: 0,
        TotalTime: 0,
        ScteNumber: 0
      }
      this.subeventList.forEach((item, index) => {
        if (item.timingIn != undefined && item.timingOut != undefined) {
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
        }
        if (item.accumulatedProgramTiming < 0) {
          item.accumulatedProgramTiming = 0
        }
        ScteMessage.maxTime += item.accumulatedProgramTiming
        if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) {
          ScteMessage.TotalTime += item.accumulatedProgramTiming
          ScteMessage.ScteNumber++
        }
        if (item.segmentId != 13) {
          if (index == 0) {
            item.timingIn = this.eventDetail.startTime
            item.timingOut = item.timingIn + item.accumulatedProgramTiming
          } else {
            item.timingIn = lastEvent.timingOut
            item.timingOut = item.timingIn + item.accumulatedProgramTiming
          }
          item.segmentOrder = index
          item.ShowTimingIn = Outil.changeNewTime(item.timingIn)
          item.ShowTimingOut = Outil.changeNewTime(item.timingOut)
          maxTime = item.timingOut
          // Underplay Block时间为一组时间
          if (item.eventOperationType == 'Underplay Block' && parent.eventOperationType == 'Underplay Block' && item.blockId == parent.blockId) {
            parent.timingOut = item.timingOut
          } else {
            // 避免使用JSON 这种方式更高效
            parent = Object.assign({}, item)
          }
          lastEvent = item
        } else {
          item.segmentOrder = index
          item.timingIn = item.OffsetIn + parent.timingIn
          item.timingOut = item.OffsetOut + parent.timingOut
          item.ShowTimingIn = Outil.changeNewTime(item.timingIn)
          item.ShowTimingOut = Outil.changeNewTime(item.timingOut)
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
        }
      })
      this.PGMScteMessage.PGMTotalTime = ScteMessage.maxTime > 0 ? Outil.getDuration(ScteMessage.maxTime) : ''
      this.PGMScteMessage.ScteTotalTime = Outil.getDuration(ScteMessage.TotalTime)
      this.PGMScteMessage.ScteNumber = ScteMessage.ScteNumber
      if (maxTime > 0 && (!this.IsHoldEvents || maxTime > this.eventDetail.endTime) && (!timeLock || this.eventDetail.timeLock != 1 || maxTime > this.eventDetail.endTime)) {
        this.eventDetail.endTime = maxTime
      }
    },
    // 子事件Segments变化
    SegmentsChang (item) {
      item.sourceId = ''
      item.fileName = ''
      item.blockId = ''
      item.UnderplayClip = ''
      item.timingOut = item.timingIn
      item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
      item.accumulatedProgramTiming = 0
      // 清空事件选择以及文件选择
      this.$set(item, 'eventOperationType', null)
      this.$set(item, 'fileId', null)
      item.sonEventMediaDuration = 0
      if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) {
        item.timingOut = item.timingIn + this.ScteDuration * 1000
        item.accumulatedProgramTiming = item.timingOut - item.timingIn
        item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
        this.getTemplate(item, 0)
        this.$set(item, 'eventOperationType', 'Scte only')
      } else if (item.segmentId == 13) {
        this.$set(item, 'eventOperationType', 'Logo')
        item.iframeInfoParams = {
          id: '',
          // name: 'Logo',
          state: 'in',
          type: '',
          title: '',
          value: '',
          sceneId: '',
          regionId: ''
        }
        item.singularInfoParams = {
          subCompositionName: '',
          state: 'in',
          type: 0,
          payloadKey: '',
          payloadValue: ''
        }
        item.OffsetIn = 0
        item.OffsetOut = 0
        // 添加logo，crawl校验
        // this.TypeChecking(item, index)
      }
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 类型校验
    TypeChecking (subevent, index) {
      const key = index - 1
      if (key < 0) {
        subevent.segmentId = null
        return
      }
      if (this.subeventList[key] == 13) {
        this.TypeChecking(subevent, key)
      } else {
        subevent.timingIn = this.subeventList[key].timingIn
        subevent.timingOut = this.subeventList[key].timingOut
        subevent.ShowTimingIn = Outil.changeNewTime(subevent.timingIn)
        subevent.ShowTimingOut = Outil.changeNewTime(subevent.timingOut)
        subevent.OffsetIn = 0
        subevent.OffsetOut = 0
      }
    },
    // scteType类型变化
    ScteTypeChange (item) {
      item.blockId = ''
      item.UnderplayClip = ''
      item.fileId = ''
      item.fileName = ''
      item.sonEventMediaDuration = 0
      if (item.eventOperationType == 'Scte only') {
        item.timingOut = item.timingIn + this.ScteDuration * 1000
        item.accumulatedProgramTiming = item.timingOut - item.timingIn
        item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
      } else if (item.eventOperationType == 'Underplay Block') {
        item.blockId = Outil.return32Str()
        item.UnderplayClip = 1
        this.UnderplayClipList[item.blockId] = 1
      } else if (item.eventOperationType == 'Underplay clip') {
        this.getTemplate(item, 1)
      }
      // 推送操作
      this.PushUndo()
    },
    getTemplate (item, type) {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/templates'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (item == 'init') {
              if (this.EventMotionSelect == 2 && result.defaultSeason != null && result.defaultSeason != undefined) {
                this.eventDetail.season = result.defaultSeason
              }
              return
            }
            if (result.enableUnderplayClip) {
              if (!type) {
                this.$set(item, 'eventOperationType', 'Underplay clip')
              }
              const pitchOnFile = {
                ...result.fileInfo,
                id: result.fileInfo.fileId
              }
              this.SubeventFileSelect(pitchOnFile, item, item.segmentOrder)
            } else {
              if (!type) {
                this.$set(item, 'eventOperationType', 'Scte only')
              }
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    // 删除子事件
    deleteSubevent (subevent, index) {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerCalendarEventsDeleteSubevent', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutCalendarEventsDeleteSubevent', '/pop')
      }
      let DeleteSubeventList = []
      if ((subevent.segmentId == 2 || subevent.segmentId == 11 || subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block') {
        if (subevent.UnderplayClip) {
          DeleteSubeventList = this.subeventList.splice(index, this.UnderplayClipList[subevent.blockId])
        } else {
          DeleteSubeventList = this.subeventList.splice(index, 1)
          this.UnderplayClipList[subevent.blockId] -= 1
        }
      } else if (subevent.segmentId == 13 && (subevent.eventOperationType == 'Flowics' || subevent.eventOperationType == 'Singular')) {
        DeleteSubeventList = this.subeventList.splice(index, this.UnderplayClipList[subevent.blockId])
      } else {
        DeleteSubeventList = this.subeventList.splice(index, 1)
      }
      // 编辑时删除的已经存在的子事件
      DeleteSubeventList.forEach(item => {
        if (item.id) {
          this.DeleteSubeventList.push(item)
        }
      })
      // 子事件时间格式化
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    FlowicsParamSelect (data, item, index) {
      const controls = data.data.controls
      const textArr = Object.values(controls)
      item.iframeInfoParams = {
        id: data.value[2],
        // name: 'Logo',
        state: 'in',
        type: textArr.length == 0 ? 2 : 0,
        title: '',
        value: '',
        sceneId: data.value[0],
        regionId: data.value[1]
      }
      // 先去掉logoText和hashText 再添加
      this.subeventList = this.subeventList.filter(v => {
        return (v.blockId != item.blockId) || (v.iframeInfoParams.type == 0) || (v.iframeInfoParams.type == 2)
      })
      this.UnderplayClipList[item.blockId] = 1
      let obj
      textArr.forEach((v, i) => {
        obj = {
          segmentId: item.segmentId,
          eventOperationType: item.eventOperationType,
          blockId: item.blockId,
          flowics: 0,
          fileId: '',
          OffsetIn: item.OffsetIn,
          OffsetOut: item.OffsetOut,
          timingIn: item.timingIn,
          timingInTime: '00:00:00',
          timingOut: item.timingOut,
          timingOutTime: '00:00:00',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          black: 0,
          segmentOrder: index + i + 1,
          iframeToken: this.SingularMessage.flowicsToken,
          iframeInfoParams: {
            id: data.value[2],
            // name: 'Logo',
            state: 'in',
            type: 1,
            title: v.id,
            value: v.value,
            sceneId: data.value[0],
            regionId: data.value[1]
          }
        }
        this.subeventList.splice(index + i + 1, 0, obj)
        this.UnderplayClipList[item.blockId] += 1
        // 推送操作
        this.PushUndo()
      })
    },
    // 添加子事件
    addSubevent (type, index, item) {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerCalendarEventsAddSubevent', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutCalendarEventsAddSubevent', '/pop')
      }
      let segmentOrder = 0
      if (type == 'end') {
        segmentOrder = this.subeventList.length
      } else {
        segmentOrder = index + 1
        if (((item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) && item.eventOperationType == 'Underplay Block') || (item.segmentId == 13 && (item.eventOperationType == 'Flowics' || item.eventOperationType == 'Singular'))) {
          segmentOrder = index + this.UnderplayClipList[item.blockId]
        }
      }
      const subevent = {
        ShowTimingIn: '',
        timingIn: 0,
        ShowTimingOut: '',
        timingOut: 0,
        segmentOrder,
        accumulatedProgramTiming: 0,
        durationEdit: false
      }
      if (type == 'end') {
        this.subeventList.push(subevent)
      } else {
        this.subeventList.splice(segmentOrder, 0, subevent)
      }
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 新增addUnderplayClip
    addUnderplayClip (item, index) {
      const segmentOrder = index + this.UnderplayClipList[item.blockId]
      const lastEvent = this.subeventList[segmentOrder - 1]
      const timingIn = lastEvent.timingOut
      const ShowTimingIn = Outil.changeNewTime(timingIn)
      const obj = {
        segmentId: item.segmentId,
        eventOperationType: item.eventOperationType,
        blockId: item.blockId,
        UnderplayClip: 0,
        fileId: '',
        timingIn,
        ShowTimingIn,
        timingOut: timingIn,
        ShowTimingOut: ShowTimingIn,
        accumulatedProgramTiming: 0,
        segmentOrder,
        durationEdit: false
      }
      this.subeventList.splice(index + this.UnderplayClipList[item.blockId], 0, obj)
      this.UnderplayClipList[item.blockId] += 1
      // 推送操作
      this.PushUndo()
    },
    // Reference Media序号问题
    SerialNumberSort () {
      let SerialNumber = 0
      // 转换显示时间
      this.subeventList.forEach((item, index) => {
        if (item.segmentId == 1) {
          SerialNumber++
          item.SerialNumber = SerialNumber
        }
      })
    },
    // 子事件的时间校验以及计算时间间隔
    DateChange (subevent, type, index) {
      // 赋予时间
      if (subevent.ShowTimingIn) {
        subevent.timingIn = new Date(
          `${this.eventDetail.newdate} ${subevent.ShowTimingIn}`
        ).getTime()
      }
      if (subevent.ShowTimingOut) {
        subevent.timingOut = new Date(
          `${this.eventDetail.newdate} ${subevent.ShowTimingOut}`
        ).getTime()
      }
      if (type == 'In') {
        subevent.timingOut = subevent.timingIn + subevent.accumulatedProgramTiming
        subevent.ShowTimingOut = Outil.changeNewTime(subevent.timingOut)
        // 修改第一个事件的开始时间做同步主事件时间
        if (index == 0 && subevent.timingIn) {
          this.eventDetail.startTime = subevent.timingIn
          this.AllEventTime.EventStarttime = this.eventDetail.startTime
        }
      }
      // 结束时间应大于开始时间
      if (subevent.timingIn && subevent.timingOut && subevent.timingOut - subevent.timingIn < 0) {
        const newdate = Outil.changeNewDate(subevent.timingOut + 24 * 60 * 60 * 1000, 1)
        subevent.timingOut = new Date(`${newdate} ${subevent.ShowTimingOut}`).getTime()
        subevent.ShowTimingOut = Outil.changeNewTime(subevent.timingOut)
      }
      // 计算时间间隔
      if (subevent.timingIn && subevent.timingOut) {
        this.$set(
          subevent,
          'accumulatedProgramTiming',
          subevent.timingOut - subevent.timingIn
        )
      }

      if (subevent.timingIn < this.eventDetail.startTime) {
        const newdate = Outil.changeNewDate(subevent.timingIn + 24 * 60 * 60 * 1000, 1)
        subevent.timingIn = new Date(`${newdate} ${subevent.ShowTimingIn}`).getTime()
        subevent.timingOut = subevent.timingIn + subevent.accumulatedProgramTiming
      }

      if (subevent.segmentId == 13) {
        this.countOffset(subevent)
      }
      if (subevent.segmentId == 1) {
        this.countReferenceMedia()
      } else if (subevent.segmentId == 4 || subevent.segmentId == 5 || subevent.segmentId == 10 || ((subevent.segmentId == 2 || subevent.segmentId == 11 || subevent.segmentId == 14) && subevent.eventOperationType != 'Scte only')) {
        this.OtherVideoOvertime(subevent, index)
        // const MediaDuration = subevent.timingOut - subevent.timingIn
        // if (subevent.sonEventMediaDuration && MediaDuration > subevent.sonEventMediaDuration) {
        //   subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
        //   this.$message.info(this.$t('lang.mediaTimeOverstep'))
        // }
      }
      // 子事件时间格式化
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 触发时间选择
    TriggerTimeSelect (type, index) {
      if (type == 'SecondaryOffsetIn') {
        this.$refs.SecondaryOffsetIn[index].focus()
      } else if (type == 'SecondaryOffsetOut') {
        this.$refs.SecondaryOffsetOut[index].focus()
      }
    },
    // 计算偏移量
    countOffset (subevent) {
      let parent = {}
      let IsHint = false
      this.subeventList.forEach((item, index) => {
        if (item.segmentId != 13) {
          // Underplay Block时间为一组时间
          if (item.eventOperationType == 'Underplay Block' && parent.eventOperationType == 'Underplay Block' && item.blockId == parent.blockId) {
            parent.timingOut = item.timingOut
          } else {
            parent = JSON.parse(JSON.stringify(item))
          }
        } else {
          if (!(parent.timingIn <= item.timingIn && item.timingIn <= parent.timingOut)) {
            item.timingIn = parent.timingIn
            if (!IsHint && parent.timingOut) {
              IsHint = true
              if (item.iframeInfoParams && item.iframeInfoParams.type != 1) {
                this.$message.info(this.$t('lang.SecondaryStartTime'))
              }
            }
          }
          if (!(parent.timingIn <= item.timingOut && item.timingOut <= parent.timingOut)) {
            item.timingOut = parent.timingOut
          }
          item.OffsetIn = item.timingIn - parent.timingIn
          item.OffsetOut = item.timingOut - parent.timingOut
        }
      })
      if (subevent && subevent.segmentId == 13 && subevent.eventOperationType == 'Flowics') {
        this.subeventList = this.subeventList.map((item, index) => {
          if (item.blockId == subevent.blockId && item.iframeInfoParams.type != 1) {
            this.mainFlowicsParams = item
            return item
          } else if (item.blockId == subevent.blockId && item.iframeInfoParams.type == 1) {
            return {
              ...item,
              OffsetIn: this.mainFlowicsParams.OffsetIn,
              OffsetOut: this.mainFlowicsParams.OffsetOut,
              ShowTimingIn: this.mainFlowicsParams.ShowTimingIn,
              ShowTimingOut: this.mainFlowicsParams.ShowTimingOut,
              timingIn: this.mainFlowicsParams.timingIn,
              timingOut: this.mainFlowicsParams.timingOut
            }
          } else {
            return item
          }
        })
      } else if (subevent && subevent.segmentId == 13 && subevent.eventOperationType == 'Singular') {
        this.subeventList = this.subeventList.map((item, index) => {
          if (item.blockId == subevent.blockId && item.singularInfoParams.type != 1) {
            this.mainFlowicsParams = item
            return item
          } else if (item.blockId == subevent.blockId && item.singularInfoParams.type == 1) {
            return {
              ...item,
              OffsetIn: this.mainFlowicsParams.OffsetIn,
              OffsetOut: this.mainFlowicsParams.OffsetOut,
              ShowTimingIn: this.mainFlowicsParams.ShowTimingIn,
              ShowTimingOut: this.mainFlowicsParams.ShowTimingOut,
              timingIn: this.mainFlowicsParams.timingIn,
              timingOut: this.mainFlowicsParams.timingOut
            }
          } else {
            return item
          }
        })
      }
    },
    // 偏移量时间转换
    formatSeconds (time) {
      time = Math.ceil(time / 1000)
      return Outil.formatSecondsChange(time)
    },
    // 选择source
    SelectSource (FileMessage) {
      this.eventDetail.sourceType = 1
      this.eventDetail.tname = FileMessage.name
      this.$set(this.eventDetail, 'tpeerid', FileMessage.sourceId)
      this.eventDetail.ttype = FileMessage.type
      const videoTimes = this.programDuration * 1000
      this.videoTimes = this.programDuration
      this.eventDetail.eventMediaDuration = 0
      this.countReferenceMedia(videoTimes)
      // 推送操作
      this.PushUndo()
    },
    // 空白占位符选择文件后编辑颜色
    BlankEditColor () {
      if (this.eventDetail.color == 'rgb(255, 255, 255)' && this.eventDetail.tpeerid) {
        this.eventDetail.color = 'rgb(255, 192, 0)'
      }
    },
    // 选择颜色
    chooseColor (item) {
      this.eventDetail.color = item.value
      this.mostSwitch.ColorShow = false
      this.PushUndo()
    },
    // 复制事件
    copyEvent () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerCalendarEventDuplicate', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutCalendarEventDuplicate', '/pop')
      }
      this.EventMotionSelect = 2
      this.CompileType = 'note'
      this.eventDetail.liveStatus = 0
      this.eventDetail.multipleModelType = 0
      this.IsCopyEvent = true
      this.subeventList.forEach((item) => {
        delete item.id
      })
      this.PushUndo()
    },
    // 请求前参数处理
    RequestBeforeData (type) {
      this.SegmentTimeFormat(type)
      this.eventDetail.eventSegments = []
      this.eventDetail.addEventSegments = []
      this.eventDetail.deleteEventSegments = []
      if (!this.eventDetail.tpeerid) {
        this.eventDetail.color = 'rgb(255, 255, 255)'
      }
      // type 1 编辑 0创建
      if (type) {
        this.subeventList.forEach((item) => {
          if (item.id) {
            this.eventDetail.eventSegments.push(item)
          } else {
            this.eventDetail.addEventSegments.push(item)
          }
        })
        // 删除
        const deleteSegments = this.oldEventMessage.eventSegments.filter(item => {
          return this.eventDetail.eventSegments.every(v => {
            return item.id != v.id
          })
        })
        this.eventDetail.deleteEventSegments = deleteSegments
      } else {
        this.eventDetail.eventSegments = this.subeventList
      }
      this.eventDetail.holdEventRundownTemplate = this.IsHoldEvents ? 1 : 0
      this.eventDetail.multipleModelType = this.eventDetail.multipleModelType ? 1 : 0
      if (this.eventDetail.multipleModelType && (this.eventDetail.startTime != this.eventDetail.endTimeOfBeforeEvent)) {
        this.eventDetail.moveFixedEvent = this.followOnDialog.type
        this.eventDetail.moveFixedEventEndTime = this.followOnDialog.endTime
      }
      const param = JSON.parse(JSON.stringify(this.eventDetail))
      param.record = param.record ? 1 : 0
      param.replay = param.replay ? 1 : 0
      if (param.sourceType == 0) {
        param.record = 0
        param.replay = 0
      }
      param.pgmEndScte = param.pgmEndScte ? 1 : 0
      param.pgmStartScte = param.pgmStartScte ? 1 : 0
      if (param.recurType == 4) {
        param.custom = this.LoopData
      }
      return param
    },
    // follow on模式弹框弹出之前需要的数据
    async followOnDataRequire () {
      await this.axios({
        method: 'post',
        url: Outil.getUrl('/event/getFirstGap'),
        data: { currentTime: this.eventDetail.endTime, programId: this.$BehaviorSyns.getProgramId() }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.followOnDialog.endTime = res.data.result.time
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
          this.updateEventLoading = false
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // follow on模式弹框选择事件
    followOnSelect (type) {
      this.followOnDialog.type = type
      if (type == 0) {
        if (this.LoopData.recurType > 0) {
        // 循环事件并且选择了follow On模式
          this.followOnAndRecur()
        } else {
          this.SaveQuest(-1)
        }
      } else {
        // this.$message.warning(this.$t('lang.takeSometime'))
        this.SaveQuest(-1)
      }
    },
    // 循环事件和follow on冲突解决弹框
    followOnAndRecur () {
      // 循环事件并且选择了follow On模式
      this.$confirm(this.$t('lang.followSureConfirm'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        showClose: false,
        closeOnClickModal: false,
        customClass: 'followONtips'
      }).then(() => {
        this.SaveQuest(0)
      }).catch(() => {

      })
    },
    // 保存事件
    async  SaveEvent () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerCalendarEventEditSave', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutCalendarEventEditSave', '/pop')
      }
      this.BlankEditColor()
      const param = this.eventDetail
      if (!param.title && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (!param.rpeerid) {
        this.$message.error(this.$t('lang.rEmpty'))
        return
      }
      if (param.title.indexOf('/') >= 0) {
        this.$message.error(`"/" ${this.$t('lang.notAllowedName')}`)
        return
      }
      if (this.saveLock) {
        return
      }
      // 有间隙需要选择弹框
      if (this.saveEventDetail.multipleModelType == 0 && this.eventDetail.multipleModelType == 1 && (this.eventDetail.startTime != this.eventDetail.endTimeOfBeforeEvent)) {
        await this.followOnDataRequire()
        this.followOnDialog.show = true
        return
      }
      // 无间隙不需要弹框
      if (this.LoopData.recurType > 0) {
        if ((this.saveEventDetail.multipleModelType == 0 && this.eventDetail.multipleModelType == 1) || (this.eventDetail.eventModelType == 1)) {
          this.followOnAndRecur()
          return
        }
        this.LoopDialog = {
          switch: true,
          Operation: 'update'
        }
      } else {
        this.SaveQuest(-1)
      }
    },
    SaveQuest (editType) {
      const param = this.RequestBeforeData(1)
      if (editType != -1) {
        param.editType = editType
      }
      if (this.picthOnEvent.endTime != param.endTime && param.nextFollowOnEvent) {
        this.$confirm(this.$t('lang.followONtips'), '', {
          confirmButtonText: this.$t('lang.Confirm'),
          cancelButtonText: this.$t('lang.cancel'),
          showClose: false,
          closeOnClickModal: false,
          customClass: 'followONtips'
        }).then(() => {
          this.saveRequire(param)
        }).catch(() => {

        })
      } else {
        this.saveRequire(param)
      }
    },
    saveRequire (param) {
      this.followOnDialog.loading = true
      this.saveLock = true
      this.updateEventLoading = true
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/updateEvent'),
        data: param,
        timeout: 60000,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        this.saveLock = false
        this.followOnDialog.loading = false
        if (res.data.errorCode == '0x0') {
          this.updateEventLoading = false
          this.OperationSuccess() // 关闭弹窗
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
          this.updateEventLoading = false
        }
      })
        .catch((err) => {
          this.saveLock = false
          this.updateEventLoading = false
          this.followOnDialog.loading = false
          console.log(err)
        })
    },
    // 创建事件
    CreateEvent () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerCalendarCreateEvent', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutCalendarCreateEvent', '/pop')
      }
      const param = this.RequestBeforeData(0)
      if (!param.title && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (!param.rpeerid) {
        this.$message.error(this.$t('lang.rEmpty'))
        return
      }
      if (param.title.indexOf('/') >= 0) {
        this.$message.error(`"/" ${this.$t('lang.notAllowedName')}`)
        return
      }
      this.updateEventLoading = true
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/add'),
        data: param,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.OperationSuccess() // 关闭弹窗
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
        this.updateEventLoading = false
      }).catch(() => {
        this.updateEventLoading = false
      })
    },
    // 删除事件
    DeleteEvent () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerCalendarEventDelete', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutCalendarEventDelete', '/pop')
      }
      const Time = new Date().getTime()
      const liveStatus = this.eventDetail.liveStatus == 4 || this.eventDetail.liveStatus == 5 || this.eventDetail.liveStatus == 6 || this.eventDetail.liveStatus == 1
      if (Time > this.eventDetail.startTime && !liveStatus) {
        this.$message(this.$t('lang.executedCanntDeleted'))
        return
      } else if (liveStatus && this.eventDetail.endTime < Time) {
        return
      }
      if (this.LoopData.recurType > 0) {
        this.LoopDialog = {
          switch: true,
          Operation: 'delete'
        }
        return
      }
      this.DeleteQuest(0)
    },
    async DeleteQuest (deleteType) {
      let deleteTips
      if (this.eventDetail.liveStatus === 1) {
        await this.getPreview()
        deleteTips = (this.NewLiveStatus.status == 4 || this.NewLiveStatus.status == 9) ? this.$t('lang.deleteLiveTips') : this.$t('lang.deleteLiveEventTips')
      } else {
        deleteTips = this.$t('lang.prompEnsureDel')
      }
      this.$confirm(deleteTips, '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        this.updateEventLoading = true
        this.axios({
          method: 'post',
          url: Outil.getUrl('/event/delete'),
          data: { ids: [this.eventDetail.id], deleteType },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.updateEventLoading = false
            this.$message({
              message: this.$t('lang.success'),
              type: 'success'
            })
            this.OperationSuccess() // 关闭弹窗
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            this.updateEventLoading = false
          }
        }).catch(() => {
          this.updateEventLoading = false
        })
      })
        .catch(() => {
        // 取消操作
        })
    },
    // 获取预览状态
    async getPreview () {
      const startTime = new Date().getTime()
      await this.axios({
        method: 'post',
        url: Outil.getUrl('/program/runningEventStatus'),
        data: {
          startTime
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.NewLiveStatus = res.data.result
          } else if (res.data.errorCode == '80602014') {
            this.NewLiveStatus = {
              status: 0
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 保存 删除 创建 操作成功
    OperationSuccess () {
      this.$emit('OperationSuccess')
    },
    // 关闭弹出框
    closeCreateBox () {
      this.$emit('closeCreateBox')
    },
    // DelayBit变化
    DelayBitChange (key) {
      this.mostSwitch[key] = false
      if (key == 'editDelay') {
        let delay
        if (this.eventDetail.delay) {
          delay = Number(this.eventDetail.delay.replace(/[^\d.]/g, ''))
        }
        if (this.Rversions) {
          this.eventDetail.delay = delay < 0.3 ? '0.3' : this.eventDetail.delay
        } else {
          this.eventDetail.delay = delay < 0.5 ? '0.5' : this.eventDetail.delay
        }
        this.eventDetail.delay = delay > 50 ? '50' : this.eventDetail.delay
      } else if (key == 'editBit') {
        let bitrate
        if (this.eventDetail.bitrate) {
          bitrate = Number(this.eventDetail.bitrate.replace(/[^\d.]/g, ''))
        }
        this.eventDetail.bitrate =
          bitrate < 100 ? '100' : this.eventDetail.bitrate
        this.eventDetail.bitrate =
          bitrate > 10240 ? '10240' : this.eventDetail.bitrate
      }
      // 推送操作
      this.PushUndo()
    },
    // 转换颜色
    ColorTransition (color) {
      const colorName = this.colorArr.filter((item) => item.value == color)
      return colorName[0] ? colorName[0].name : 'purple'
    },
    dealRepeatOrigin (event) {
      const repeatOriginStart = event.repeatOrigin.split('-')[0]
      const repeatOriginEnd = event.repeatOrigin.split('-')[1]
      const repeatOrigin = Outil.TransitionCurrentTime1(new Date(repeatOriginStart * 1)) + ' - ' + Outil.TransitionCurrentTime2(new Date(repeatOriginEnd * 1))
      this.repeatOrigin = repeatOrigin
    },
    // 判断是查看还是创建，赋予数据
    async  estimateOperate (type, UpdateEventMessage) {
      this.picthOnEvent.sourceType = 0
      this.saveEventDetail = UpdateEventMessage || this.picthOnEvent

      if (type == 'update' || type == 'init') {
        if (UpdateEventMessage.repeatOrigin) {
          this.dealRepeatOrigin(UpdateEventMessage)
        }
        // if (type == 'update') {
        //   this.eventDetail = JSON.parse(JSON.stringify(UpdateEventMessage))
        // } else {
        // 请求数据处理
        this.eventDetail = this.InitQuestDis(UpdateEventMessage)
        // }
      } else if (this.EventMotionSelect == 2) {
        const eventDetail = JSON.parse(JSON.stringify(this.picthOnEvent))
        this.eventDetail = {
          ...eventDetail,
          category: '',
          thumbnail: '',
          secondaryTpeerid: '',
          record: 0,
          replay: 0,
          season: 0,
          episode: 1
        }
      } else {
        this.eventDetail = JSON.parse(JSON.stringify(this.picthOnEvent))
      }
      this.getTimeLock()
      this.eventDetail.multipleModelType = !!this.eventDetail.multipleModelType
      this.eventDetail.record = !!this.eventDetail.record
      this.eventDetail.replay = !!this.eventDetail.replay
      this.eventDetail.pgmEndScte = !!this.eventDetail.pgmEndScte
      this.eventDetail.pgmStartScte = !!this.eventDetail.pgmStartScte
      // hold on event默认值
      this.eventDetail.eventModelType = this.eventDetail.eventModelType ? this.eventDetail.eventModelType : 0
      this.eventDetail.color = this.eventDetail.color
        ? this.eventDetail.color
        : 'rgb(255, 192, 0)'
      //   计算事件的时长，时间间隔
      this.eventDetail.duration = this.eventDetail.duration
        ? this.eventDetail.duration
        : this.eventDetail.endTime - this.eventDetail.startTime
      //   查看和编辑
      if (this.EventMotionSelect == 0 || this.EventMotionSelect == 1) {
        // 判断源是视频还是t
        if (this.eventDetail.ttype) {
          if (
            ['video', 'file'].includes(
              this.eventDetail.ttype && this.eventDetail.ttype.toLowerCase()
            )
          ) {
            this.eventDetail.sourceType = 0
          } else {
            this.eventDetail.sourceType = 1
          }
        }
        // 取delay,bitrate
        if (this.eventDetail.parameters) {
          const parameters =
            typeof this.eventDetail.parameters == 'object'
              ? this.eventDetail.parameters
              : JSON.parse(this.eventDetail.parameters)
          this.eventDetail.reporter = parameters.reporter
          this.eventDetail.delay = parameters.delay
          this.eventDetail.bitrate = parameters.bitrate
          this.eventDetail.subtitleUrl = parameters.subtitleUrl
        }
        // 判断开始时间是否小于现在，小于则正在执行
        if (this.eventDetail.startTime <= new Date().getTime() && this.eventDetail.endTime > new Date().getTime()) {
          this.mostSwitch.IsProgress = true
        } else {
          this.mostSwitch.IsProgress = false
        }
        //   子事件
        if (this.eventDetail.eventSegments.length) {
          this.subeventSwitch = this.eventDetail.eventSegments.length > 0 ? 1 : 0
          this.subeventList = JSON.parse(
            JSON.stringify(this.eventDetail.eventSegments)
          )
        }
      } else if (this.EventMotionSelect == 2) {
        this.eventDetail.rname = this.fixedDevice.name
        this.eventDetail.rpeerid = this.fixedDevice.peerId
      }

      // 选中的TakeElement
      if (this.eventDetail.highlightEvent) {
        this.TakeElementObj.selectId = this.eventDetail.highlightEvent
        this.TakeElementObj.switch = true
      }
      // 获取时区
      this.eventDetail.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      // 存一下所有事件的时间
      this.AllEventTime.EventStarttime = this.picthOnEvent.startTime
      this.AllEventTime.EventTime = this.eventDetail.duration
      this.setSubeventDateLimit()
    },
    // 初始化请求数据处理
    InitQuestDis (UpdateEventMessage) {
      const NewEvent = JSON.parse(JSON.stringify(UpdateEventMessage))
      NewEvent.eventSegments = NewEvent.eventSegments.map((v, i) => {
        if (v.segmentId == 13 && v.fileId && v.fileId.startsWith('0x_')) {
          v.fileIdd = v.fileId.slice(3, v.fileId.length)
          v.showColor = true
        } else {
          v.fileIdd = v.fileId
          v.showColor = false
        }
        return v
      })
      this.oldEventMessage = JSON.parse(JSON.stringify(NewEvent))
      return NewEvent
    },
    // 设置子事件选择范围并且转化显示时间
    setSubeventDateLimit () {
      if (this.eventDetail.startTime && this.eventDetail.endTime) {
        // 子事件选择范围
        this.subeventDateLimit =
          `${Outil.changeNewTime(this.eventDetail.startTime)
          } - '23:59:59'`
        // 存一下日期
        this.eventDetail.newdate = Outil.changeNewDate(this.eventDetail.startTime, 1)
        // 初始时间的变化
        const EventTimeChange =
          this.eventDetail.startTime - this.AllEventTime.EventStarttime

        // 修改的上一次时间存一下
        this.AllEventTime.EventStarttime = this.eventDetail.startTime
        let SerialNumber = 0
        this.UnderplayClipList = {}
        // PGMSCTE的信息展示
        const ScteMessage = {
          maxTime: 0,
          TotalTime: 0,
          ScteNumber: 0
        }
        // 转换显示时间
        this.subeventList.forEach((item, index) => {
          if (item.segmentId == 1) {
            SerialNumber++
            item.SerialNumber = SerialNumber
          }
          if ((item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) && item.eventOperationType == 'Underplay Block') {
            if (this.UnderplayClipList[item.blockId]) {
              item.UnderplayClip = 0
              item.blockId && (this.UnderplayClipList[item.blockId] += 1)
            } else {
              item.UnderplayClip = 1
              item.blockId && (this.UnderplayClipList[item.blockId] = 1)
            }
          } else if (item.segmentId == 13 && (item.eventOperationType == 'Flowics' || item.eventOperationType == 'Singular')) {
            if (this.UnderplayClipList[item.blockId]) {
              item.blockId && (this.UnderplayClipList[item.blockId] += 1)
            } else {
              item.blockId && (this.UnderplayClipList[item.blockId] = 1)
            }
          }
          if (EventTimeChange) {
            item.timingIn = item.timingIn + EventTimeChange
            item.timingOut = item.timingOut + EventTimeChange
          }
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
          item.ShowTimingIn = item.timingIn
            ? Outil.changeNewTime(item.timingIn)
            : item.timingIn
          item.ShowTimingOut = item.timingOut
            ? Outil.changeNewTime(item.timingOut)
            : item.timingOut
          item.durationEdit = false
          ScteMessage.maxTime += item.accumulatedProgramTiming
          if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) {
            ScteMessage.TotalTime += item.accumulatedProgramTiming
            ScteMessage.ScteNumber++
          }
        })
        this.PGMScteMessage.PGMTotalTime = ScteMessage.maxTime > 0 ? Outil.getDuration(ScteMessage.maxTime) : ''
        this.PGMScteMessage.ScteTotalTime = Outil.getDuration(ScteMessage.TotalTime)
        this.PGMScteMessage.ScteNumber = ScteMessage.ScteNumber
        this.countOffset()
        this.subeventList = JSON.parse(JSON.stringify(this.subeventList))
      }
    },
    changeTimingFile (id) {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/eventTemplate/resolveSegments', {
        fileId: id
        // defaultScteDuration: this.form.scteSpliceDurationDefault
      }, {
        contentType: 'application/json;charset=UTF-8'
      }).then((res) => {
        this.loading = false
        if (res.data.errorCode == '0x0') {
          const data = res.data.result
          if (data.eventSegments && data.eventSegments.length > 0) {
            let SerialNumber = 0
            data.eventSegments.forEach((item, index) => {
              if (item.segmentId == 1) {
                SerialNumber++
                item.SerialNumber = SerialNumber
              }
              if (item.segmentId == '2' && !item.eventOperationType) item.eventOperationType = 'Scte only'
              item.accumulatedProgramTiming = (item.timingOut - item.timingIn) * 1000
              if (index == 0) {
                item.timingIn = this.eventDetail.startTime + item.timingIn * 1000
                item.timingOut = item.timingIn + item.accumulatedProgramTiming
              } else {
                item.timingIn = data.eventSegments[index - 1].timingOut
                item.timingOut = item.timingIn + item.accumulatedProgramTiming
              }
            })
            this.DeleteSubeventList = this.subeventList
            this.subeventList = data.eventSegments
            this.SegmentTimeFormat()
            const videoTimes = this.videoTimes * 1000
            if (this.videoTimes) {
              this.TimeReferenceMedia(videoTimes)
            }
            // 推送操作
            this.PushUndo()
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取objectkey
    async getObjectKey (userId) {
      const param = {
        directory: 'INCOMING',
        userId,
        bucket: this.RegionInfo.bucket
      }
      await this.axios
        .post('/file/get-user-bucket-dir', param, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.FolderObjectKey = res.data.result.objectKey
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    async getMcpList () {
      if (!this.FolderObjectKey) {
        const OwnerUserid = Outil.getProgramReceiver('ownerUserId')
        await this.getObjectKey(OwnerUserid)
      }
      const params = {
        isDirectory: false,
        suffixList: ['csv', 'xml'],
        region: this.RegionInfo.region,
        service: this.RegionInfo.ServerName,
        bucketId: this.RegionInfo.bucketId,
        type: 3,
        objectKeyLike: this.FolderObjectKey,
        nameLike: this.McpObj.condition,
        pageIndex: this.McpObj.pageNum,
        pageSize: this.McpObj.pageSize
      }
      this.axios.post('/file/query', params, { requestBase: 'GATEWAY' }).then((res) => {
        if (res.data.errorCode === '0x0') {
          if (params.pageIndex >= res.data.result.pages) {
            this.bindScroll.noMore = true
          }
          if (params.pageIndex > 1) {
            this.mcpTimingList = this.mcpTimingList.concat(res.data.result.records)
          } else {
            this.mcpTimingList = res.data.result.records
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    getNextPage () {
      if (this.bindScroll.loading || this.bindScroll.noMore) return
      this.McpObj.pageNum += 1
      this.getMcpList()
    },
    // 搜索timming文件列表
    searchFile (value) {
      this.McpObj.pageNum = 0
      this.McpObj.condition = value
      this.getMcpList()
    },
    // 判断是否有Element
    JudgeElement () {
      if (this.TakeElementObj.selectId && this.TakeElementObj.selectId != '0') {
        let eventTemplateId = ''
        this.subeventList.forEach((item) => {
          if (item.id == this.TakeElementObj.selectId) {
            eventTemplateId = item.eventTemplateId
          }
        })
        if (eventTemplateId) this.CurrentPlayoutEvent = eventTemplateId
      }
    },
    // 获取预览状态
    getPreviewStatus () {
      const startTime = new Date().getTime()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/program/runningEventStatus'),
        data: {
          startTime
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            const currentEvent = res.data.result
            if (!this.CurrentPlayoutEvent) {
              this.CurrentPlayoutEvent = currentEvent.playlistSonEventId
            }
          } else if (res.data.errorCode == '80602014') {
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
          this.JudgeElement()
        }
      }).catch(() => {})
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    },
    // 展示时间
    displayTime (startTime, endTime, type) {
      const startDate = Outil.getDateTime(new Date(startTime))
      const endDate = Outil.getDateTime(new Date(endTime))
      const startDay =
        `${startDate.year}-${startDate.month}-${startDate.day}`
      const endDay = `${endDate.year}-${endDate.month}-${endDate.day}`
      // type有值不返回日期
      if (type) {
        return `${startDate.hour}:${startDate.min}:${startDate.s} - ${endDate.hour
          }:${endDate.min}:${endDate.s}`
      } else if (startDay == endDay) {
        return `${startDay} ${startDate.hour}:${startDate.min}:${startDate.s
            } - ${endDate.hour}:${endDate.min}:${endDate.s}`
      } else {
        return `${startDay} ${startDate.hour}:${startDate.min} - ${endDay} ${endDate.hour
            }:${endDate.min}`
      }
    },
    // SourceType类型改变
    SourceTypeChange () {
      this.eventDetail.fileId = ''
      this.eventDetail.tpeerid = ''
      this.eventDetail.tname = ''
    },
    // 只允许数字
    onlyNumbers (key) {
      if (key == 'Season') {
        const inputValue = this.eventDetail.season
        this.eventDetail.season = inputValue.replace(/[^0-9]/g, '')
      } else if (key == 'Episode') {
        const inputValue = this.eventDetail.episode
        this.eventDetail.episode = inputValue.replace(/[^0-9]/g, '')
      }
      this.PushUndo('input')
    }
  },
  beforeDestroy () {
    this.EditSend('close')
    window.removeEventListener('unload', this.EditSend)
    this.UndoActionPro.stop()
  }
}
</script>

<style scoped lang="less">
.PopupBox {
  // position: fixed;
  // top: 0;
  // left: 0;
  .createBooking {
    position: absolute;
    max-height: 465px;
    background-color: #252525;
    border-radius: 4px;
    z-index: 1999;
    padding: 16px;
    padding-right: 20px;
    color: #999;
    font-size: 16px;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.78);
    .EventWrapTitle {
      margin-bottom: 15px;
      .closeCreateBox {
        position: absolute;
        right: 20px;
        top: 15px;
      }

      .CompileTitle {
        display: flex;
        font-size: 16px;
      }
      .separator {
        padding: 0 8px;
      }
      li.active {
        color: #33ab4f;
      }
    }
    .EventUpdateandCreate {
      .note {
        width: 362px;
        max-height: 345px;
        overflow-y: auto;
        padding-right: 5px;
        .color_box {
          height: 100%;
          padding-right: 22px;
          position: relative;
        }
        .color_opt {
          width: 255px;
          height: 40px;
          background: #333;
          color: #999;
          border-radius: 4px;
          position: absolute;
          right: -11px;
          top: 31px;
          padding: 10px 0;
          padding-left: 6px;
          font-size: 12px;
          line-height: 20px;
          z-index: 10000;
          display: flex;
          ul {
            display: flex;
            li {
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 10px;
            }
          }
        }
        .color {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          margin-top: 4px;
          box-sizing: content-box;
        }
        .el-icon-caret-bottom {
          font-size: 20px;
          position: absolute;
          top: 16%;
          right: 0px;
          transform: translateY(-50%);
          transform: rotate(0deg);
          transition: 0.3s;
        }
        .el-icon-caret-bottom.top {
          transform: rotate(-180deg);
        }

        textarea {
          width: 362px;
          border: none;
          outline: none;
          background: #444;
          border-radius: 4px;
          height: 60px;
          color: #999;
          font-size: 12px;
          line-height: 15.6px;
          padding: 2px 18px 2px 10px;
          box-sizing: border-box;
        }
        ::v-deep.c_item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: space-between;
          text-align: left;
          p{
            margin: 0;
          }
          .HouseIDKey{
            color: #999;
            font-size: 14px;
          }
          .HouseIDVaule{
            color: #999;
            font-size: 14px;
            margin-left: 6px;
            input {
              width: 285px;
            }
          }
          input {
            height: 30px;
            background-color: #444;
            color: #dbdbdb;
            border: none;
            outline: none;
            border-radius: 4px;
            text-indent: 10px;
            font-size: 12px;
            box-sizing: border-box;
            text-align: left;
          }
          .el-checkbox {
            // margin-right: 48px;
            margin: 0;
            .el-checkbox__inner {
              width: 15px;
              height: 15px;
              background: transparent;
              border: 1px solid #DCDFE6;
            }
          }
          .is-checked {
            .el-checkbox__inner {
              background: #33ab4f;
              border-color: transparent;
            }
            .el-checkbox__inner::after {
              border-color: #fff;
              left: 4px;
              top: 0;
            }
          }

          .el-checkbox__label {
            border-color: #dbdbdb;
          }
        }
        ::v-deep.c_item.des{
          position: relative;
          .desNum{
            position: absolute;
            bottom: 0;
            right: 2px;
            font-size: 12px;
          }
        }
        .showOnly {
          margin-bottom: 0px;
          justify-content: start;
          .HouseIDKey{
            width: 60px;
            margin-right: 2px;
          }
        }
        ::v-deep .Output {
          .el-select__input {
            background-color: transparent;
          }
        }
        ::v-deep.EventTitle {
          input {
            width: 300px;
          }
        }
        .moreMode{
          width: 48%;
          /deep/ .el-input{
              input{
                height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
              }
            }
            /deep/ .el-select-dropdown{
              text-align: left;
              width: 100%;
            }
        }
        }
        .eventMode{
          justify-content: space-between;
        }
        ::v-deep .RepeatTypeSelect{
          .el-select {
            width: 100%;
          }
          .el-input__inner{
            height: 32px;
            color: #dbdbdb;
            font-size: 12px;
          }
          input::-webkit-input-placeholder{
            color:#999
          }
        }
        ::v-deep .SctePgmStart{
          text-align: left;
          .PublicFileSelect{
            margin-left: 25px;
            .el-select-dropdown{
              width: 330px;
            }
            .el-input__inner {
              width: 330px;
              height: 32px;
            }
          }
        }
        .createEventMessage {
          color: #999999;
          font-size: 12px;
        }
        ::v-deep .repeatOrigin{
          font-size: 12px
        }
        ::v-deep .CategoryReporter,.EPGFields{
          justify-content: space-between;
          input {
            width: 170px;
          }
          .el-input__inner{
            width: 170px;
            height: 32px;
            color: #dbdbdb;
            font-size: 12px;
          }
          input::-webkit-input-placeholder{
            color:#999
          }
        }
        .DuplicateHint{
          font-size: 12px;
          line-height: 14px;
          color:#FD5454;
          text-align: left;
          padding-left: 10px;
        }
        .timeSelete {
          .time_opt {
            width: 170px;
            height: 30px;
            line-height: 26px;
            color: #000;
            border: none;
            border-radius: 4px;
            ::v-deep .el-date-editor.el-input {
              width: 100%;
            }
            ::v-deep input.el-input__inner {
              width: 100%;
              height: 30px;
              background: #444;
              padding-left: 10px;
              border: none;
              color: #dfdfdf;
              font-size: 12px;
              padding-right: 0;
              line-height: initial;
            }
            ::v-deep .el-input__prefix,
            .el-input__suffix-inner {
              display: none;
            }
          }
          .to {
            color: #999;
            line-height: 30px;
            font-size: 12px;
            i{
              font-size: 18px;
            }
            .icon-lock2{
              color: #33AB4F;
            }
          }
        }
        ::v-deep .RecordSelete {
          margin-bottom: 10px;
          .Recordhalf {
            display: inline-block;
            width: 50%;
          }
        }
      }
      .EventsWrap {
        width: 844px;
        height: 287px;
        .PGMScteMessage{
          position: absolute;
          right: 42px;
          top: 15px;
          width: 500px;
          text-align: right;
          font-size: 16px;
          span{
            margin-right: 10px;
          }
        }
        ::v-deep .ReferenceMedia {
          margin-bottom: 10px;
          display: flex;
          .MediaType {
            width: 110px;
          }
          .MediaSelect {
            // width: 208px;
            display: flex;
            align-items: center;
            margin-right: 15px;
            position: relative;
            .ReferenceMediaSelect {
              width: 189px;
              .el-select {
                width: 189px;
              }
            }
            .Link{
              font-size: 13px;
              color: #666666;
              margin: 0 5px;
              .el-loading-spinner {
                top: 25px;
                .circular{
                  height: 15px;
                  width: 15px;
                }
              }
            }
            .HighLinght{
              width: 196px;
              height: 35px;
              border: 3px solid #0c6;
              position: absolute;
              top: -3px;
              left: -4px;
            }
            .ReserveHighLinght{
              left: 211px;
            }
          }
          .MediaTiming{
            input{
              width: 180px;
            }
          }
          .Thumbnails {
            margin-left: 20px;
            input{
              width: 200px;
              height: 30px;
              background-color: #444;
              color: #44A4FD;
            }
          }
          .el-input--suffix {
            background: #444444;
            .el-input__inner {
              height: 30px;
              font-size: 12px;
              color: #dbdbdb;
              padding-left: 10px;
            }
          }
          .el-select-dropdown__item {
            font-size: 12px;
            height: 30px;
            padding-left: 10px;
          }
          .el-select__caret {
            color: #999999;
          }
          .el-scrollbar__wrap {
            text-align: left;
            max-width: 240px;
            .el-scrollbar__view {
              width: 100%;
            }
          }
        }
        .EventsTitle {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border-bottom: 2px solid #444444;
          height: 30px;
          font-size: 14px;
          color: #8c8a88;
          .MediaIndex{
            width: 16px;
          }
          .Title-item {
            width: 110px;
            margin-right: 8px;
            text-align: left;
          }
          .timePicker{
            width: 100px;
          }
          .FilePicker{
            width: 235px;

          }
          .Duration {
            width: 82px;
            margin-right: 0;
          }
        }
        ::v-deep .EventsListWrap {
          height: 217px;
          overflow-y: auto;
          .EventsList {
            height: 40px;
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #444444;
            position: relative;
            .LiveEventItem{
              background: rgb(0, 255, 128);
              opacity: .4;
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0px;
              left: 0px;
              z-index: 999;
              pointer-events:none;
            }
            .MediaIndex{
              width: 16px;
              font-size: 12px;
            }
            .Title-item {
              width: 110px;
              margin-right: 8px;
              text-align: left;
              .noSelete {
                font-size: 14px;
                color: #dbdbdb;
              }

              .el-input--suffix {
                background: #444444;
                .el-input__inner {
                  height: 30px;
                  font-size: 12px;
                  color: #dbdbdb;
                  padding-left: 10px;
                  padding-right: 0;
                }
              }
              .el-select-dropdown__item {
                font-size: 12px;
                height: 30px;
                padding-left: 10px;
              }
              .el-select__caret {
                color: #999999;
              }
              .fileSelete {
                .SelectTakeElement {
                  border: 2px solid #33AB4F;
                }
                .LiveElement{
                  border: 2px solid #E56464;
                }
                .el-input--suffix {
                  .el-input__inner{
                    padding-left: 5px;
                    padding-right: 16px;
                  }
                  .el-input__suffix{
                    right: -2px;
                  }
                }
                .el-popper {
                  max-width: 200px;
                }
                .el-select-dropdown__wrap {
                  max-height: 200px;
                }
                .showRed{
                  .el-input--suffix {
                    .el-input__inner{
                      color: red;
                    }
                  }

                }
              }
              .UnderplayClipVideo {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .PublicFileSelect{
                  width: 85%;
                }
                .addUnderplayClip{
                  width: 10%;
                }
              }
              .flowicsContent{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .flowicsSelect{
                  width: 85%;
                }
                .flowicsAdd{
                  width: 10%;
                }
              }
              .logoAndHashText{
                font-size: 12px;
              }
            }
            .timePicker {
              width: 100px;
              position: relative;
              .el-input--suffix {
                width: 100px;
                .el-input__inner {
                  width: 100px;
                  border: 1px solid #353535;
                  background: #444444;
                }
                .el-input__prefix,
                .el-input__suffix {
                  display: none;
                }
              }
            .SecondaryOffset{
              width: 100px;
              height: 30px;
              position: absolute;
              top: 0;
              left: 0;
              background: #444444;
              z-index: 1;
              color: #dbdbdb;
              line-height: 30px;
              font-size: 12px;
              padding-left: 8px;
            }
            }
            .FilePicker{
              width: 235px;
              .referenceName{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
                color: #dfdfdf;
              }
              .flowicsSelect{
              ::v-deep  .el-cascader{
                  line-height: 0px;
                }
              }
              .el-select{
                width: 100%;
              }
            }
            .Duration-item {
              width: 82px;
              margin-right: 0;
              position: relative;
              .Duration {
                width: 75px;
                font-size: 12px;
                color: #dfdfdf;
                height: 32px;
                line-height: 32px;
                text-align: left;
                margin-right: 0;
                background: #444444;
                border-radius: 4px;
                padding: 0 8px;
                cursor: pointer;
              }
            }
            .operation-item{
              display: flex;
              span {
                opacity: .5;
              }
              .leftM{
                margin-left: 20px;
              }
            }
          }
          .addSubevent {
            text-align: right;
            font-size: 12px;
            color: #cccccc;
            padding-right: 5px;
          }
        }
      }
      .device {
        width: 362px;
        height: 210px;
        color: rgb(102, 102, 102);
        margin: 0 9px;
        .d_item {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border-bottom: 1px solid rgba(153, 153, 153, 1);
          font-size: 12px;
          padding: 0 20px 0 10px;
          display: flex;
          justify-content: space-between;
          .val {
            color: #999;
            width: 56%;
            text-align: right;
            position: relative;
          }
          .ValSelet {
            padding-right: 10px;
            span {
              height: 31px;
              overflow: hidden;
            }
          }
          .ValSelet::before {
            content: '';
            position: absolute;
            top: 60%;
            left: 94%;
            border: 6px solid;
            transform: translateY(-50%);
            border-color: transparent;
            border-top-color: #999;
            transition: 0.3s;
          }
          .ValSelet.up:before {
            top: 23%;
            transform: rotate(-180deg);
          }
          .input {
            float: right;
            height: 25px;
            width: 135px;
            margin-top: 3px;
            margin-right: -20px;
            border: none;
            padding-left: 10px;
            padding-right: 20px;
            box-sizing: border-box;
            color: #999;
            background-color: transparent;
            text-align: right;
            outline: none;
          }
          .scte_ipt {
            color: #000;
          }
          .delay,
          .bitrate {
            text-align: left;
            background-color: #fff;
          }
        }
        .d_item.source {
          input {
            float: right;
            border: none;
            height: 25px;
            width: 100px;
            padding-left: 10px;
            padding-right: 25px;
            margin-right: -20px;
            margin-top: 3px;
            box-sizing: content-box;
            color: #000;
          }
        }
      }
      .ChangeLog{
         width: 362px;
         height: 250px;
         overflow-y: auto;
        .log-item{
          font-size: 14px;
          text-align: left;
          padding-bottom: 24px;
          .log-time {
            color: #666666;
            line-height: 16px;
          }
          .log-user{
            padding-left: 16px;
            color: #666666;
            line-height: 16px;
          }
          .log-content{
            color: #DBDBDB;
            line-height: 16px;
            margin-top: 6px;
          }
        }
      }
    }
    .create_footer {
      margin-top: 10px;
      height: 30px;
      display: flex;
      justify-content: flex-end;
      position: relative;
      .TakeElement{
        position: absolute;
        left: 10px;
        bottom: 0px;
        width: 100px;
        height: 30px;
        // line-height: 28px;
        text-align: center;
        border: 1px solid #999999;
        font-size: 12px;
        color: #fff;
        border-radius: 4px;
        cursor: pointer;
        background: transparent;
        padding: 7px;
      }
      .NOElement{
        color: #666;
        border-color: #666;
      }
      .TakeNextSubevent {
        position: absolute;
        left: 125px;
        bottom: 0px;
        width: 80px;
        height: 30px;
        // line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        background: #F4425C;
        border-radius: 4px;
        cursor: pointer;
        padding: 9px 20px
      }
      .DetailButton {
        width: 147px;
        display: flex;
        justify-content: space-between;
        margin-right: 50px;
      }
      button {
        width: 75px;
        height: 30px;
        background: #999;
        color: #fff;
        border: none;
        border-radius: 4px;
        font-size: 12px;
      }
      .ComplieButton {
        width: 155px;
        display: flex;
        justify-content: flex-end;
      }
      .save,
      .edit {
        background-color: #0c6;
        margin-left: 16px;
      }
      .delete {
        width: 56px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid rgba(153, 153, 153, 1);
        background: transparent;
      }
      .copy {
        color: #39aa50;
        border: 1px solid #39aa50;
        background: transparent;
      }
      .end_live {
        background: #f00;
        color: #fff;
      }
    }
    ::v-deep  .el-input{
      .el-input__inner{
        height: 30px;
        line-height: 30px;
        border: 1px solid #444;
        background: #444444;
      }
    }

  .Arrows {
    border: 12px solid transparent;
    border-top-color: #252525;
    border-right-color: #252525;
    position: absolute;
    left: 60px;
    top: -10px;
    box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
    transform: rotate(-45deg);
  }
  .createBookingRight {
    transform: translateX(-100%);
    // margin-left: -100%;
  }
  .createBookingBottom {
    transform: translateY(-100%);
  }
  .createBookingRightBottom {
    transform: translate(-100%, -100%);
  }
  .createBookingRight .Arrows {
    left: auto;
    right: 60px;
    transform: rotate(-45deg);
  }
  .createBookingBottom .Arrows {
    top: 100%;
    transform: rotate(135deg);
    margin-top: -15px;
  }
  // .createBookingRightBottom::before {
  //   left: 100%;
  //   top: 100%;
  //   transform: rotate(135deg) translateX(-20px);
  // }
  ::v-deep .el-scrollbar__thumb {
    background: transparent;
  }

  .green {
    border: 1px solid #0a9a5a;
    background: #0fbe71;
  }
  .skyblue {
    background-color: #46c9e1;
    border: 1px solid #0ca595;
  }
  .blue {
    background-color: rgb(14,107,209);
    border: 1px solid #126ed3;
  }
  .orange {
    background-color: #ffc573;
    border: 1px solid #d8a966;
  }
  .pink {
    background-color: #ff6a92;
    border: 1px solid #ee3656;
  }
  .yellow {
    background-color: #ffc000;
    border: 1px solid #ffc000;
  }
  .purple {
    background-color: #9248c7;
    border: 1px solid #9248c7;
  }
}
</style>
<style lang='less'>
.followONtips{
  width: 450px !important;
}

.flowicsSelect{
  .el-cascader{
    line-height: 0px;
  }
}
</style>
